import {
    Component,
    OnInit,
    Output,
    EventEmitter,
    OnDestroy,
    ElementRef,
    ViewChild,
    AfterViewInit,
    ViewChildren,
    QueryList,
} from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { ChatServices } from '@app/services/chat.service';
import { QuiltSuggestedQuestionsService } from '@app/services/quilt-suggested-questions.service';
import {
    Subject,
    Subscription,
    debounceTime,
    distinctUntilChanged,
    firstValueFrom,
    lastValueFrom,
} from 'rxjs';
import { IChatInteraction } from '@common/models/Chat/IChatInteraction';
import { IChat } from '@common/models/Chat/IChat';
import { ChatStatus } from '@common/enums/ChatStatus';
import { InteractionType } from '@common/enums/InteractionType';
import { IChatDocument } from '@common/models/Chat/IChatDocument';
import { MessageService } from 'primeng/api';
import { ChatState } from '@common/enums/ChatState';
import { IDocument } from '@common/models/Document/IDocument';
import { DocumentStatus } from '@common/enums/DocumentStatus';
import { WebSocketService } from '@app/services/webSocket.service';
import { ChatType } from '@common/enums/ChatType';
import TurndownService from 'turndown';
import { htmlToText } from 'html-to-text';
import { DomSanitizer, SafeUrl } from '@angular/platform-browser';
import { IChatRequest, IImagesRequest } from '@common/models/Chat/IChatRequest';
import { CHAT_RESPONSE_DEBOUNCE_MS } from '@app/config/chat';
import { ISourceURL } from '@common/models/Document/IESGDocuments';
import { ITableTag } from "@common/models/ITags";
import { IDeltaTable } from '@common/models/Document/IDeltaTable';
import { IChatConfig, IESGConfig } from '@common/models/Chat/IChatConfig';
import { IAddDoctoChatAPIResp } from '@common/models/Chat/IAddDoctoChatAPIResp';
import { ChatDocumentComponent } from '../chat-document/chat-document.component';
import { IModelRegistry } from '@common/models/ModelRegistry/IModelRegistry';
import { IChatResponseEvent } from '@common/models/Chat/IChatResponseEvent';
import { ChatResponseEventType } from '@common/enums/ChatResponseEventType';
import { AngularEditorComponent, AngularEditorConfig } from '@kolkov/angular-editor';
import { LLMReasoningEffort } from '@common/enums/LLMReasoningEffort';
import { LLMModelType } from '@common/enums/LLMModelType';
import { ReasoningModeInput } from '@app/types';
import { DEEP_RESEARCH_MODEL_NAME } from '@app/config/deepResearch';
import { getRouteParamChatType, sortPromptTemplates } from '@app/utils';
import { ALL_DOCUMENT_FILE_FORMATS, ALL_IMAGE_FILE_FORMATS, CSV_FILE_FORMATS, EXCEL_FILE_FORMATS } from '@common/constants';
import { DocumentService } from '@app/services/document.service';
import { PromptService } from '@app/services/prompt.service';
import { PromptTemplateType } from '@app/types/PromptTemplate';
import { CHAT_TYPE_ROUTE_MAP } from '@app/constants';
@Component({
    selector: 'app-chat-main',
    templateUrl: './chat-main.component.html',
    styleUrls: ['./chat-main.component.scss'],
    providers: [MessageService],
})
export class ChatMainComponent
    implements OnInit, OnDestroy, AfterViewInit
{

    /** Output Props */
    @Output() interactionsemit: EventEmitter<number> = new EventEmitter();

    /** View Queries */
    @ViewChild('chatDocuments') chatDocuments: ChatDocumentComponent;
    @ViewChild('editorInput') editorElementRef!: AngularEditorComponent;
    @ViewChild('fileUploadDoc') fileUpload: ElementRef;
    @ViewChild('fileUploadDocMainInput') fileUploadDocMainInput: ElementRef;
    @ViewChild('mainContainer') mainContainer: ElementRef;
    @ViewChild('scrollContainer') private readonly scrollContainer: ElementRef;
    @ViewChild('textarea') textarea: ElementRef;
    
    /** View Children */
    @ViewChildren('interactionContainer') interactionContainer: QueryList<ElementRef>;

    /** Subscriptions */
    private chatLLMRespStatusDebounceSubscription: Subscription = new Subscription();
    private chatRespDebounceSubscription: Subscription = new Subscription();
    private chatTypeObsSub: Subscription;
    private chatSelectedSub: Subscription;
    chatReplySubscription: Subscription = new Subscription();
    ChatResponseSub: Subscription;
    createChatSub!: Subscription;
    fileUploadSub: Subscription = new Subscription();
    getChatDocsSub: Subscription;
    getchatInteractionsSub!: Subscription;
    sendChatSub: Subscription;
    updateChatsSub: Subscription = new Subscription();
    userStateSub: Subscription;

    /** Subject Objects */
    chatRespUpdateDebounce = new Subject<any>();
    chatLLMRespStatusUpdateDebounce = new Subject<any>();


    /** Constants */
    /** 1. Chat Status */
    ChatStateActive: string = ChatState.Active;
    ChatStateInactive: string = ChatState.InActive;
    ChatStateArchived: string = ChatState.Archived;
    chatStatusWaiting: ChatStatus = ChatStatus.Waiting;
    /** 2. Chat Type */
    ESGChatType = ChatType.ESG;
    QECChatType: ChatType = ChatType.QEC;
    codeInterpreterChatType: ChatType = ChatType.codeInterpreter;
    deepResearchChatType: ChatType = ChatType.deepResearch;
    openWebChatType:ChatType=ChatType.agenticWorkflow;
    codeInterpretorChatType:ChatType=ChatType.codeInterpreter;
    quiltChatType = ChatType.quilt;
    /** 3. Model Type */
    LLMReasoningModelType = LLMModelType.Reasoning;
    
    // Tracks if the user has interacted with the prompt dropdown
    hasPromptDropdownBeenInteractedWith: boolean = false;
    chatMessages: IChatInteraction[] = [];
    activeChat: IChat;
    inputText: string;
    uploadingPlaceholderText = 'Please wait while the file is being uploaded...';
    isUploadPlaceholderActive = false;
    generatingReplyBool: boolean = false;
    loadingChats: boolean = false;
    chatPeriod: string;
    modelAppearance: string;
    showTypeWriterResponse: boolean = false;
    showRegeneration: boolean = false;
    isNewChat: boolean = false;
    allLLMModels: IModelRegistry[] = [];
    supportedLLMModels: IModelRegistry[] = [];
    responseTimeout: boolean = true;
    chatReply: string = '';
    reasoningSummary: string = '';
    progressSummary: string = '';
    
    getChatDocumentsLoader: boolean = false;
    sendQuestionLoader: boolean = false;
    showToolbar: boolean = false;
    
    isStructutredChat: boolean = false;
    
    reasoningModeChatTypeConfig = {
        [this.ESGChatType]: false,
        [this.openWebChatType]: false,
        [this.codeInterpreterChatType]: false,
        [this.deepResearchChatType]: false,
        [this.QECChatType]: false
    }
    // Reasoning mode options for dropdown (Default maps to LOW)
    reasoningModeOptions: ReasoningModeInput[] = [
        { label: 'Low', value: LLMReasoningEffort.LOW, description: "Low Reasoning Mode", default: true },
        { label: 'High', value: LLMReasoningEffort.HIGH, description: "High Reasoning Mode" }
    ];
    filesUploaded: File[] = [];
    filesUploadedImgUrls: { url: SafeUrl; loading: boolean }[] = [];
    currentChatRequest: IChatRequest;
    currentQuestionImages: any = {};
    

    unStructuredChatTypes = [
            'normal',
            'PDFDocument',
            ChatType.StructuredUnstructuredDocs,   // includes Unstrucutred Doc as well
            ChatType.ESGStructuredUnstructuredDocs,
            ChatType.agenticWorkflow
    ];

    editorConfig: AngularEditorConfig = {
        editable: true,
        height: 'auto',
        minHeight: '54px',
        maxHeight: '384px',
        minWidth: '0',
        width:'100%',
        translate: 'yes',
        enableToolbar: true,
        showToolbar: false,
        placeholder: 'Write your message here',
        defaultParagraphSeparator: 'p',
        defaultFontName: '"IBM Plex Sans", sans-serif',
        outline: false,
        toolbarHiddenButtons: [
            [
                'strikeThrough',
                'underline',
                'italic',
                'justifyLeft',
                'justifyCenter',
                'justifyRight',
                'justifyFull',
                'subscript',
                'superscript',
                'heading',
                'fontName',
            ],
            [
                'fontSize',
                'textColor',
                'backgroundColor',
                'customClasses',
                'link',
                'unlink',
                'insertImage',
                'insertVideo',
                'insertHorizontalRule',
                'toggleEditorMode', 'clearFormatting'
            ],
        ],
    };
    
    
    get dynamicEditorConfig(): AngularEditorConfig {
        return {
          ...this.editorConfig,
          placeholder: this.chatType === this.QECChatType
            ? '*  Please first select the table to initiate WFDO chat'
            : 'Write your message here',
        };
    }
    //  SearchDocuments
    showSearchDocumentsBool: boolean = false;
    showQECDocumentsBool: boolean = false;
    showESGDocumentsBool: boolean = false;
    ESGDocumentLoaderDocs : Record<number,boolean> = {}
    ESGDeletionLoaderTags : Record<number,boolean> = {}
    ESGDeletionLoaderSources : Record<number,boolean> = {}
    
    chatDocsProcessingCount: number=0
    memoryToggle: boolean = false;

    showDragOverlay: boolean = false;
    dragCounter: number = 0;
    // De-dupe guard (class fields)
    private _lastPasteSig: string | null = null;
    private _lastPasteAt = 0; // ms epoch

    selectedModel: IModelRegistry;
    selectedReasoningMode: ReasoningModeInput;

    // Prompt template selection state
    promptTemplates: PromptTemplateType[] = [];
    selectedPromptTemplate: PromptTemplateType | null = null;
    promptLoading: boolean = false;
    promptError: string | null = null;
    userId: string | null = null;

    // Streaming Properties
    isStreamingStartByteReceived = false;
    suggestedQuestions: string[] = [];
    questionsLoading = false;


    constructor(
        private readonly chatServices: ChatServices,
        private readonly messageService: MessageService,
        private readonly webSocketService: WebSocketService,
        private readonly docService: DocumentService,
        private readonly promptService: PromptService,
        private readonly quiltSuggestedQuestionsService: QuiltSuggestedQuestionsService,
        private readonly sanitizer: DomSanitizer,
        private readonly route: ActivatedRoute,
        private readonly router: Router
    ) {
        this.initializeDebounceSubscription();
    }

    public isDragDropAllowed():boolean
    {
        return this.chatDocuments?.countDocProcessing===0;
    }

    get chatDocumentList() {
        return this.chatServices.getChatDocumentList();
    }

    get chatType() {
        return this.chatServices?.chatType;
    }

    get defaultWFDOTables() {
        return this.docService.defaultWFDOTables
    }

    get lastMessage(){
        return this.chatMessages?.at(-1);
    }

    get allChats() {
        return this.chatServices.getAllChatsValue();
    }

    private get hasAttachedDocuments(): boolean {
        const chatDocumentsCount = this.chatDocumentList?.length ?? 0;
        const activeChatDocumentsCount = this.activeChat?.chatDocument?.length ?? 0;
        const pendingDocumentsCount = this.chatDocuments?.documentsList?.length ?? 0;

        return chatDocumentsCount + activeChatDocumentsCount + pendingDocumentsCount > 0;
    }

    private get hasImagesAttached(): boolean {
        return (this.filesUploadedImgUrls?.length ?? 0) > 0 ||
            (this.filesUploaded?.length ?? 0) > 0 ||
            this.isImageUploadedInCurrentChat();
    }

    get isMemoryChatToggleDisabled(): boolean {
        const unsupportedChatTypes: ChatType[] = [
            this.openWebChatType,
            this.codeInterpreterChatType,
            this.deepResearchChatType,
            this.ESGChatType,
            this.QECChatType,
            this.quiltChatType,
            ChatType.HRDocuments,
            ChatType.UnstructuredDocument,
            ChatType.StructuredDocument,
            ChatType.StructuredUnstructuredDocs,
        ];

        const modelLacksMemorySupport = this.selectedModel?.featuresSupported?.memorySupport === false;

        return unsupportedChatTypes.includes(this.chatType) ||
            this.hasAttachedDocuments ||
            this.hasImagesAttached ||
            modelLacksMemorySupport;
    }

    private syncMemoryChatAvailability(): void {
        if (this.isMemoryChatToggleDisabled && (this.memoryToggle || this.chatServices.memoryChat)) {
            this.memoryToggle = false;
            this.chatServices.memoryChat = false;
        }
    }

    initializeDebounceSubscription(): void {
        // Make sure to unsubscribe from any previous subscriptions before reinitializing
        this.chatRespDebounceSubscription.unsubscribe();
        this.chatLLMRespStatusDebounceSubscription.unsubscribe();

        const tempDebounceSubscription = this.chatRespUpdateDebounce
            .pipe(debounceTime(CHAT_RESPONSE_DEBOUNCE_MS), distinctUntilChanged())
            .subscribe(({ chatId, quesID, documentChat }) => {
              let currentInteraction = this.chatMessages.find(msg => msg.interactionId === quesID);
              if(currentInteraction?.chatStatus === ChatStatus.Waiting){
                this.longPollChatInteractionById(chatId, quesID, documentChat);}
            });
        
        const llmResponseStatusDebounceSubscription = this.chatLLMRespStatusUpdateDebounce
            .pipe(debounceTime(5000), distinctUntilChanged())
            .subscribe(({ chatId, quesID, documentChat }) => {
              let currentInteraction = this.chatMessages.find(msg => msg.interactionId === quesID);
              if(currentInteraction?.chatStatus === ChatStatus.Waiting){
                this.longPollLLMResponseStatus(chatId, quesID, documentChat);}
            });

        this.chatRespDebounceSubscription = tempDebounceSubscription;
        this.chatLLMRespStatusDebounceSubscription = llmResponseStatusDebounceSubscription;
    }
    
    ngOnInit(): void {
        void this.initializeComponent();
        
        // Subscribe to chat selection events from the service
        this.chatSelectedSub = this.chatServices.getChatSelectedObs().subscribe((event) => {
            this.updateChat(event);
        });
    }

    private async initializeComponent(): Promise<void> {
        let chatId = '';
        let chatType = '';
        try {
            const paramMap = await firstValueFrom(this.route.paramMap);
            chatId = paramMap.get('id');
            chatType = paramMap.get('type');
            console.debug('[ChatMainComponent] URL chatId:', chatId);

            const parsedChatType = CHAT_TYPE_ROUTE_MAP[chatType];
            // Route to new Vanilla Chat (Default) for invalid chat type
            if (!parsedChatType) {
                this.router.navigate(['/chat']);
                return;
            }
            this.chatServices.updateChatTypeStatus(parsedChatType);

            if (chatId && chatId !== '' && chatId !== 'new') {
                const paramChat = await firstValueFrom(this.chatServices.getchatById(chatId));
                if (!paramChat) {
                    throw new Error(`Cannot load chat ${chatId}`);
                }
                this.chatServices.updateActiveChat(paramChat);
                this.chatServices.updateActiveChatObs(paramChat);
            }
        } catch (error) {
            console.error(`[ChatMainComponent] loading chat ${chatId} error`, error);
            this.router.navigate(['/chat']);
        }
        
        // Fetch all LLM models on init, guard against race with activeChat
        this.activeChat = this.chatServices.getActiveChat();
        const initialChatId = this.activeChat?.chatId;
        this.chatServices.fetchAllModels().subscribe({
            next: (models) => {
                // Only apply if chatId hasn't changed
                if (this.activeChat?.chatId === initialChatId) {
                    this.allLLMModels = models;
                    this.supportedLLMModels = models;
                    this.selectedModel = this.defaultModel;
                    if (this.selectedModel) {
                        this.chatServices.setModelSelection(this.selectedModel);
                    }
                    // Always sync model dropdown after model fetch
                    this.syncDropdownsToActiveChat();
                    console.log('Fetched LLM models:', models);
                }
            },
            error: (err) => {
                console.error('Failed to fetch LLM models', err);
            }
        });

        this.chatServices.UserMe().subscribe((user) => { this.userId = (user as any)?.id; this.connectToSocket(); });
        if (this.activeChat) {
            this.loadingChats = true;
            this.getChatInteractions();
            // Immediately sync dropdowns to activeChat
            this.syncDropdownsToActiveChat();
        }
        this.chatServices.getActiveChatObs().subscribe((res: IChat) => {
            this.isStreamingStartByteReceived = false;

            if (!res) {
                this.activeChat = res;
                return;
            }

            const isChatSwitch = this.activeChat?.chatId !== res.chatId;

            if (isChatSwitch) {
                this.activeChat = res;
                this.getChatInteractions();
                this.syncDropdownsToActiveChat();
            } else {
                // Same chat updated (e.g., documents added/removed) – refresh bindings without reloading history
                this.activeChat = { ...this.activeChat, ...res };
            }
        });

        // Fetch prompt templates from backend, guard against race with activeChat
        const promptFetchChatId = this.activeChat?.chatId;
        this.promptLoading = true;
        this.promptService.fetchPromptTemplates().subscribe({
            next: (templates: PromptTemplateType[]) => {
                // Only apply if chatId hasn't changed
                if (this.activeChat?.chatId !== promptFetchChatId) {
                    // Discard stale async result
                    return;
                }
                this.promptTemplates = sortPromptTemplates(templates);

                // Set initial template selection to the chat's activePromptTemplate if it exists, otherwise Default
                if (this.activeChat?.activePromptTemplate) {
                    const found = this.promptTemplates.find(t => t.name === this.activeChat.activePromptTemplate);
                    this.selectedPromptTemplate = found || this.promptTemplates.find(t => t.name === 'Default') || this.promptTemplates[0];
                    if (!found) {
                        this.messageService.add({
                            severity: 'warn',
                            summary: 'Prompt Info',
                            detail: `Prompt "${this.activeChat.activePromptTemplate}" not found. Default prompt selected.`,
                            life: 3000
                        });
                    }
                } else {
                    this.selectedPromptTemplate = this.promptTemplates.find(t => t.name === 'Default') || this.promptTemplates[0];
                }

                // If user hasn't interacted with the prompt dropdown, programmatically trigger default selection
                if (!this.hasPromptDropdownBeenInteractedWith) {
                    const defaultTemplate =
                        this.promptTemplates.find(t => t.name === 'Default') ||
                        this.promptTemplates[0];
                    if (defaultTemplate) {
                        this.onPromptTemplateChange(defaultTemplate);
                    }
                }

                this.promptLoading = false;
            },
            error: (err) => {
                this.promptError = 'Failed to load prompt templates';
                this.promptLoading = false;
                this.messageService.add({
                    severity: 'error',
                    summary: 'Prompt Load Error',
                    detail: 'Failed to load prompt templates from backend. Please refresh or try again later.',
                    life: 5000
                });
            }
        });

        this.chatTypeObsSub = this.chatServices.getChatTypeObs().subscribe((res: ChatType) => {
            if(!this.editorConfig.editable) {
                this.setEditorEditableMode(true);
            }
            this.updateSupportedLLMModelsForSelectedChat(res);

            this.selectedReasoningMode = this.defaultReasoningEffort;
            this.syncModelAndPromptsSelection();
            
            this.maybeLoadQuiltSuggestedQuestions(res);
            this.syncMemoryChatAvailability();
        });

        this.selectedReasoningMode = this.defaultReasoningEffort;
        this.chatServices.setReasoningModeSelection(this.defaultReasoningEffort);
        this.maybeLoadQuiltSuggestedQuestions();

    }

    /**
     * Syncs Model And Prompt Selection with Chat Service
     */
    private syncModelAndPromptsSelection() {
        // Sync Reasoning Model
        this.chatServices.setReasoningModeSelection(this.defaultReasoningEffort);
        // Sync Model Selection
        this.chatServices.setModelSelection(this.selectedModel);
        // Sync Prompt Template Selection
        this.chatServices.setPromptTemplateSelection(this.selectedPromptTemplate);
    }

    /**
     * Immediately synchronize dropdowns to the current activeChat's state.
     */
    private syncDropdownsToActiveChat(): void {
        // Sync prompt dropdown
        if (this.activeChat?.activePromptTemplate && this.promptTemplates?.length) {
            const found = this.promptTemplates.find(
                t => t.name === this.activeChat.activePromptTemplate
            );
            this.selectedPromptTemplate =
                found ||
                this.promptTemplates.find(t => t.name === 'Default') ||
                this.promptTemplates[0];
        } else if (this.promptTemplates?.length) {
            this.selectedPromptTemplate =
                this.promptTemplates.find(t => t.name === 'Default') ||
                this.promptTemplates[0];
        }
        // Always sync model dropdown to activeChat's selectedModel or default
        if (this.supportedLLMModels?.length) {
            if (this.activeChat?.selectedModel) {
                const foundModel = this.supportedLLMModels.find(
                    m => m.model === this.activeChat.selectedModel
                );
                this.selectedModel = foundModel || this.defaultModel;
            } else {
                this.selectedModel = this.defaultModel;
            }
        }

        // Sync Reasoning Mode Dropdown
        const activeChatReasoningMode = this.activeChat?.chatConfig?.reasoningMode;
        if(activeChatReasoningMode) {
            this.selectedReasoningMode = this.getReasoningModeInputFromValue(activeChatReasoningMode) ?? 
                this.defaultReasoningEffort;
        } else {
            // Setting Default Reasoning
            this.selectedReasoningMode = this.defaultReasoningEffort;
        }

        this.syncModelAndPromptsSelection();

    }

    get defaultModel(){
        return this.supportedLLMModels.find(model => model.defaultForFlows.includes(this.chatServices.chatType));
    }

    get defaultReasoningEffort(){
        return this.reasoningModeOptions.find(mode => mode.default);
    }

    getReasoningModeInputFromValue(reasoningMode: LLMReasoningEffort){
        return this.reasoningModeOptions.find(mode => mode.value === reasoningMode);
    }

    onEditorChange(html: string) {
    if (!this.editorElementRef) {
      console.warn('Editor element ref not yet available');
      return;
    }
    
    const editorDiv = this.editorElementRef?.textArea?.nativeElement;
    
    if (!editorDiv) {
      console.warn('Could not find .angular-editor-textarea element');
      return;
    }
    const content = html.replaceAll(/<br>/gi, '').trim();
    if(content===''){
        editorDiv.innerHTML='';
    }
        }

    updateSupportedLLMModelsForSelectedChat(currentChatType: ChatType){
        const regularChatTypes = [ChatType.ESG, ChatType.QEC, ChatType.Normal]

        if(regularChatTypes.includes(currentChatType)){

            this.supportedLLMModels = this.allLLMModels.filter(model => model.supportedChats.includes(currentChatType));
            this.selectedModel = this.defaultModel;
        }
    }

    private maybeLoadQuiltSuggestedQuestions(chatType?: ChatType): void {
        const typeToCheck = chatType ?? this.chatType;
        if (typeToCheck !== this.quiltChatType) {
            return;
        }
        if (this.suggestedQuestions.length || this.questionsLoading) {
            return;
        }
        this.questionsLoading = true;
        this.quiltSuggestedQuestionsService.getQuiltSuggestedQuestions().subscribe({
            next: (questions) => {
                this.suggestedQuestions = questions || [];
                this.questionsLoading = false;
            },
            error: (err) => {
                console.error('Failed to load quilt suggested questions', err);
                this.questionsLoading = false;
            }
        });
    }

    async connectToSocket() {
        try {
            const webSocketConnected = await this.webSocketService.isWebSocketConnected();
            if(webSocketConnected){
              console.debug('WebSocket connection is established!');
              this.chatReplySubscription.add(
                this.webSocketService.getMessages().subscribe({
                    next: (messageEvent) => {
                        const message = messageEvent;
                        if (
                            message?.data &&
                            message?.interactionId &&
                            this.chatMessages?.length > 0 &&
                            this.chatMessages.at(-1)
                                ?.interactionId == message.interactionId &&
                            this.showTypeWriterResponse &&
                            this.chatServices.interactionType !==
                                ChatType.StructuredUnstructuredDocs &&
                            this.chatServices.interactionType !==
                                ChatType.ESGStructuredUnstructuredDocs
                        ) {
                            if (message.data.text === '%START%') {

                                this.isStreamingStartByteReceived = true;

                            } else if (message.data.text === '%END%') {
                                if (message.chatType === ChatType.deepResearch) {
                                    setTimeout(() => {
                                        this.longPollLLMResponseStatus(this.activeChat.chatId, message.interactionId, message.chatType);
                                    }, 1000);
                                }

                                if(message.chatType && message.chatType === ChatType.UnstructuredDocument){
                                  setTimeout(() => {
                                    this.longPollChatInteractionById(this.chatMessages[this.chatMessages?.length - 1]?.chatId, message.interactionId,message.chatType)
                                  }, 1000);
                                }
                                let currentChatMessage = this.chatMessages.at(-1);
                                let currentResponse = currentChatMessage.response.at(-1);
                                currentResponse.text = this.chatReply;
                                currentResponse.responseEvents = [{
                                    eventType: ChatResponseEventType.Reasoning,
                                    text: this.reasoningSummary
                                }];

                                if (this.progressSummary) {
                                    currentResponse.responseEvents.push({
                                        eventType: ChatResponseEventType.Progress,
                                        text: this.progressSummary
                                    });
                                }
                                    this.scrollOnRespGeneration(false,true);
                                  this.generatingReplyBool = false
                                  this.showTypeWriterResponse = false
                            } else if (this.generatingReplyBool) {
                                const chunkData: IChatResponseEvent = message.data;
                                const eventType: ChatResponseEventType = chunkData.eventType;
                                const chunkText: string = chunkData.text ?? "";

                                if(eventType === ChatResponseEventType.OutputText){
                                    if (
                                        this.chatServices.chatType === ChatType.deepResearch
                                        && !this.isStreamingStartByteReceived
                                    ) {
                                        return;
                                    }
                                    this.chatReply = this.chatReply + chunkText;
                                } else if (eventType === ChatResponseEventType.Reasoning){
                                    this.reasoningSummary = this.reasoningSummary + chunkText;
                                } else if (eventType === ChatResponseEventType.Progress){
                                    this.progressSummary = chunkText;
                                }
                            }
                            setTimeout(() => {
                                this.scrollOnRespGeneration(true);
                            }, 300);
                        }
                    },
                    error: (error) => {
                        if (error instanceof CloseEvent) {
                            console.error('WebSocket closed unexpectedly:', error);
                              this.messageService.clear();
                              this.messageService.add({
                                  severity: 'error',
                                  summary: 'Streaming Error',
                                  detail: 'Streaming stopped unexpectedly. Please try again.',
                              });
                        } else {
                            console.error('Other WebSocket error:', error);
                        }
                    }
                })
              );
            }else{
              console.debug('WebSocket not connected. Attempting to reconnect...');
              this.webSocketService.closeConnection();
              await this.webSocketService.connectToSocket(this.userId)
              const webSocketConnected = await this.webSocketService.isWebSocketConnected()
              if (webSocketConnected) {
                console.debug('WebSocket successfully reconnected');
                this.connectToSocket();
              } else {
                  console.error('WebSocket failed to reconnect');
              }
            }
      } catch (error) {
        console.error('Error establishing WebSocket connection:', error);
        this.messageService.clear();
        this.messageService.add({
            severity: 'error',
            summary: 'Streaming Error',
            detail: error.error.message,
        });
    }
    }

    ngAfterViewInit() {
        try {
            const mainContainerElement = this.mainContainer.nativeElement;

            mainContainerElement.addEventListener('dragenter', (event: DragEvent) => {
                event.preventDefault();
                this.dragCounter++;
                this.showDragOverlay = true;
            });

            mainContainerElement.addEventListener('dragleave', (event: DragEvent) => {
                event.preventDefault();
                this.dragCounter--;
                if (this.dragCounter === 0) {
                    this.showDragOverlay = false;
                }
            });

            mainContainerElement.addEventListener('dragover', (event: DragEvent) => {
                event.preventDefault();
                event.stopPropagation();
            });

            mainContainerElement.addEventListener('drop', (event: DragEvent) => {
                event.preventDefault();
                event.stopPropagation();
                this.dragCounter = 0;
                this.showDragOverlay = false;
                if(!this.isDragDropAllowed())
                    return;


                const files = Array.from(event.dataTransfer?.files || []);

                const images = files.filter(file => ALL_IMAGE_FILE_FORMATS.includes(file.type));
                const documents = files.filter(file => ALL_DOCUMENT_FILE_FORMATS.includes(file.type));

                // Validate whether Selected Model supports Image Upload.
                // Added negative condition check to support older chat as well.
                if(images.length && this.selectedModel.featuresSupported?.imageUpload === false) {
                    this.messageService.clear();
                    this.messageService.add({
                        severity: 'error',
                        summary: 'Error',
                        detail: 'Image is not supported for the selected Model.',
                    });
                    return;
                }

                // Validate whether Selected Model supports Image Upload.
                if(documents.length && this.selectedModel.featuresSupported?.documentUpload === false){
                    this.messageService.clear();
                    this.messageService.add({
                        severity: 'error',
                        summary: 'Error',
                        detail: 'Document Upload is not supported for the selected Model.',
                    });
                    return;
                }


                if (images.length === 0 && documents.length === 0) {
                    this.messageService.add({
                        severity: 'error',
                        summary: 'Error',
                        detail: 'Only .pptx/ .docx/ .pdf/ .txt/ .xls/ .xlsx/.csv files are allowed',
                    });
                    return;
                }

                if (images.length > 0 && documents.length > 0) {
                    this.messageService.add({ severity: 'error', summary: 'Error', detail: 'Documents and Images cannot be attached together' });
                    return;
                }

                if (this.activeChat && !this.isActiveChat())
                {   this.messageService.add({
                        severity: 'error',
                        summary: 'Error',
                        detail: 'Documents or Images cannot be uploaded in inactive or archived chat',
                    });
                    return;

                }

                if (documents.length > 0) {
                    const chatType = this.chatServices.getChatType();
                    let errorMessage = '';
                    switch (chatType) {
                        case 'QEC':
                            errorMessage = 'Document upload is not allowed in WFDO';
                            break;
                        case 'ESG':
                            errorMessage = 'Document upload is not allowed in ESG';
                            break;
                        case 'codeInterpreter':
                            errorMessage = 'Document upload is not allowed in DS Playground';
                            break;
                        case 'agenticWorkflow':
                            errorMessage = 'Document upload is not allowed in Web Search';
                            break;
                        case ChatType.deepResearch:
                            errorMessage = 'Document upload is not allowed in Deep Research';
                            break;
                        case ChatType.quilt:
                            errorMessage = 'Document upload is not allowed in Quilt';
                            break;
                        default:
                            errorMessage = 'Document upload is not allowed in this chat type';
                    }
                    if (['QEC', 'ESG', 'codeInterpreter', 'agenticWorkflow', ChatType.deepResearch, ChatType.quilt].includes(chatType)) {
                        this.messageService.add({ severity: 'error', summary: 'Error', detail: errorMessage });
                        return;
                    }

                    if (this.isImageUploadedInCurrentChat()) {
                        this.messageService.add({ severity: 'error', summary: 'Error', detail: 'Document upload not permitted in image chat' });
                        return;
                    }

                    this.onFIleuploadForDocChatOnDrag(event);
                    return;
                }

                if (images.length > 0) {

                    if ((this.filesUploaded?.length ?? 0) > 0 || (this.filesUploadedImgUrls?.length ?? 0) > 0) {
                        this.messageService.add({
                        severity: 'warn',
                        summary: 'Warning',
                        detail: 'Only one image can be attached to a question. You can attach another image in next question.',
                        });
                        return;
                    }

                    if (images.length > 1) {
                        this.messageService.add({ severity: 'error', summary: 'Error', detail: 'Multiple images cannot be attached in a single question' });
                        return;
                    }

                    const chatType = this.chatServices.getChatType();
                    let errorMessage = '';
                    switch (chatType) {
                        case 'QEC':
                            errorMessage = 'Image upload is not allowed in WFDO';
                            break;
                        case 'ESG':
                            errorMessage = 'Image upload is not allowed in ESG';
                            break;
                        case 'codeInterpreter':
                            errorMessage = 'Image upload is not allowed in DS Playground';
                            break;
                        case 'agenticWorkflow':
                            errorMessage = 'Image upload is not allowed in Web Search';
                            break;
                        case ChatType.deepResearch:
                            errorMessage = 'Image upload is not allowed in Deep Research';
                            break;
                        case ChatType.quilt:
                            errorMessage = 'Image upload is not allowed in Quilt';
                            break;
                        default:
                            errorMessage = 'Image upload is not allowed in this chat type';
                    }
                    if (['QEC', 'ESG', 'codeInterpreter', 'agenticWorkflow', ChatType.deepResearch].includes(chatType)) {
                        this.messageService.add({ severity: 'error', summary: 'Error', detail: errorMessage });
                        return;
                    }

                    if (this.chatServices.getChatDocumentList()?.length > 0) {
                        this.messageService.add({ severity: 'error', summary: 'Error', detail: 'Image upload not permitted in document chat' });
                        return;
                    }

                    this.onUploadFilesDragDrop(event);
                }
            });
        } catch (err) {
            console.error('Error initializing drag-and-drop listeners:', err);
        }

        try {
            const editorTextarea = this.textarea.nativeElement
                .querySelector('.angular-editor-textarea');
            this.autoFocusInputBox();
            editorTextarea.addEventListener('keydown', (event: KeyboardEvent) => {
                    if (event.key === 'Enter') {
                        this.checkSubmit(event);
                    }
                });
        } catch (err) {
            console.error('Error in adding listener in Angular Editor', err);
        }
        
    }

    autoFocusInputBox(): void {
        if (window.innerWidth > 576) {
            try {
                this.textarea.nativeElement
                    .querySelector('.angular-editor-textarea')
                    ?.focus();
            } catch (err) {
                console.error('Error focusing input box', err);
            }
        }
    }


    /**
     * Returns true if model selection should be disabled (Web Search, DS Playground, or Deep Research enabled)
     */
    get isModelSelectionDisabled(): boolean {
        // Web Search (open web chat), DS Playground (code interpreter), or Deep Research
        return this.chatType === this.openWebChatType ||
               this.chatType === this.codeInterpreterChatType ||
               this.chatType === this.deepResearchChatType ||
               this.chatType === this.QECChatType;
    }

    /**
     * Returns the display model name based on chat type
     */
    get displayModelName(): string {
        // For Deep Research, return the model name from config
        if (this.chatType === this.deepResearchChatType) {
            return DEEP_RESEARCH_MODEL_NAME;
        }
        // For all other chat types, return the selected model from MongoDB registry
        return this.selectedModel?.model || '';
    }

    /**
     * Returns true if prompt template selection should be disabled (after first message is sent)
     */
    get isPromptSelectionDisabled(): boolean {
        // Disable dropdown after first message to lock the prompt selection
        return this.chatMessages && this.chatMessages.length > 0;
    }

    get showRegenerationButton() {
        const lastInteraction = this.chatMessages.at(-1);
        return ( 
          // If Chat Type is not DeepResearch / Quilt
          this.chatType !== this.deepResearchChatType && 
          this.chatType !== this.quiltChatType &&
          // Check if any LLM Generation / Doc Processing is in Progress
          this.showRegeneration &&
          !this.generatingReplyBool &&
          this.chatDocsProcessingCount === 0 &&
          !this.loadingChats &&
          // Check for Interaction Status, Response, Chat State
          lastInteraction &&
          lastInteraction.chatStatus !== this.chatStatusWaiting &&
          lastInteraction.response?.at(-1)?.text?.trim()?.length &&
          this.activeChat?.chatState === this.ChatStateActive
        );
      }

    setInputText(question: string) {
        this.inputText = question;
    }

    onQuestionSubmit() {
        this.responseTimeout = false;
        if (
            this.processedInputText &&
            this.processedInputText().trim() != '' &&
            this.isActiveChat()
        ) {
            this.generatingReplyBool = true;
            this.sendQuestionLoader = true;
            this.activeChat = this.chatServices.getActiveChat();
            if (this.activeChat == undefined
                || (this.activeChat.chatId == undefined
                    && this.chatServices.chatType === ChatType.QEC)) {
                this.createNewChat();
            } else {
                this.sendMessage();
            }
        }
    }

    getModelSelectionForChat(chatId: string): any {
    if (chatId && Array.isArray(this.allChats)) {
        const allChatsFlat = this.allChats.flatMap((period: any) =>
            Array.isArray(period.chats) ? period.chats : []
        );
        const chatObj = allChatsFlat.find((c: any) => c.chatId === chatId);
        return chatObj?.selectedModel || null;
    }
    return null;
    }

     async updateModelAppearance(chatId: string): Promise<void> {
        if (chatId === undefined || chatId === null)
            return;
        const modelName = this.getModelSelectionForChat(chatId);
        this.selectedModel = this.supportedLLMModels.find(model => model.model === modelName) || this.defaultModel;
    }

    async updateReasoningModeAppearance(): Promise<void> {
        const reasoningMode = this.reasoningModeOptions.find(mode => mode.value === this.activeChat.chatConfig.reasoningMode);
        this.onReasoningModeChange(reasoningMode ?? this.defaultReasoningEffort);
    }

    cancelChatInteractionResponse() {
        if (this.ChatResponseSub) {
            this.ChatResponseSub.unsubscribe();
        }
        this.ChatResponseSub = new Subscription();
    }

    async sendMessage(event?: any) {
        let question_text: string = event?.editedText || this.processedInputText();

        // Handle edited question
        if (event?.isEdit && event?.interactionId) {
            const editIndex = this.chatMessages.findIndex(msg => msg.interactionId === event.interactionId);
            if (editIndex !== -1) {
                // Update question text immediately
                this.chatMessages[editIndex].request.requestText = question_text;
                // Clear the response
                this.chatMessages[editIndex].response = [];
                this.chatMessages[editIndex].chatStatus = ChatStatus.Waiting;
                // Remove all subsequent messages
                this.chatMessages = this.chatMessages.slice(0, editIndex + 1);
            }
        }

        // ✅ CRITICAL FIX: Only sync prompt on INITIAL message (when no existing interactions)
        // This prevents overwriting existing chat prompts but ensures first message uses dropdown selection
        const isInitialMessage = !this.chatMessages || this.chatMessages.length === 0;
        if (isInitialMessage && this.selectedPromptTemplate?.name) {
            const chatId = this.activeChat?.chatId;
            console.log(`Initial message - syncing backend prompt to dropdown selection: ${this.selectedPromptTemplate.name}, chatId: ${chatId}`);
            
            try {
                await lastValueFrom(this.promptService.setActivePromptForUser(this.selectedPromptTemplate.name, chatId));
                console.log(`Successfully synced initial prompt to: ${this.selectedPromptTemplate.name}`);
                
                // Update the active chat's activePromptTemplate if there's an active chat
                if (this.activeChat && chatId) {
                    this.activeChat.activePromptTemplate = this.selectedPromptTemplate.name;
                }
            } catch (error) {
                console.error(`Failed to sync initial prompt selection:`, error);
                // Continue with message sending even if prompt sync fails
            }
        } else if (!isInitialMessage) {
            console.log(`Existing chat with ${this.chatMessages?.length} messages - keeping existing prompt, not syncing dropdown`);
        }

        if (this.showToolbar) {
            this.toggleToolbar();
        }
        this.sendQuestionLoader = true;
        this.chatReply = '';
        this.reasoningSummary = '';
        this.progressSummary = '';
        this.textarea.nativeElement
            .querySelector('.angular-editor-textarea')
            .blur();
        this.cancelChatInteractionResponse();

        if (this.filesUploaded.length === 0) {
            if ((await this.webSocketService.isWebSocketConnected()) === false) {
                await this.connectToSocket();
                this.sendMessage(event);
                return;
            }

            this.sendChatSub = this.chatServices
                .sendQuestion(
                    question_text,
                    this.activeChat.chatId,
                    InteractionType.QA,
                    event?.isEdit,
                    event?.interactionId
                )
                .subscribe({
                    next: (res: IChatInteraction) => {
                        (async () => {
                            if (res) {
                                if (res.interactionId) {
                                    try {
                                        await this.webSocketService.connectAndJoinRoom(
                                            res.userId,
                                            res.interactionId
                                        );
                                    } catch (error) {
                                        console.log(
                                            'Error connecting to WebSocket:',
                                            error
                                        );
                                    }
                                }
                                if(this.chatServices.chatType === ChatType.deepResearch){
                                    this.setEditorEditableMode(false);
                                }
                                this.inputText = null;
                                this.currentChatRequest = res.request;
                                this.removeFile(null, true);
                                this.chatReply = '';
                                this.reasoningSummary = '';
                                this.progressSummary = '';
                                this.showTypeWriterResponse = true;

                                if (event?.isEdit) {
                                    const index =
                                        this.chatMessages.findIndex(
                                            (msg) =>
                                                msg.interactionId ===
                                                event.interactionId
                                        );
                                    if (index !== -1) {
                                        // Update with new server response
                                        this.chatMessages[index] = res;
                                    }

                                } else {
                                    this.chatMessages.push(res);
                                }

                                this.interactionsemit.emit(
                                    this.chatMessages.length
                                );
                                setTimeout(() => {
                                    this.scrollToBottom();
                                }, 50);
                                this.getChatResponse(res['interactionId']);
                                this.sendQuestionLoader = false;
                            }
                        })();
                        
                },
                error: (error) => {
                    this.generatingReplyBool = false;
                    this.messageService.clear();
                    this.messageService.add({
                        severity: 'error',
                        summary: 'Error',
                        detail: error.error.message,
                    });
                },
            });
          
        } else {
            this.sendFileQuestion(question_text, InteractionType.QA);
        }
    }

    scrollOnRespGeneration(event: any, stopLoaders: boolean = false) {
        
        if (
            !event &&
            (this.chatMessages.at(-1).chatStatus !==
                ChatStatus.Waiting || stopLoaders)
        ) {
            this.generatingReplyBool = false;
            this.showTypeWriterResponse = false;
        }
    }

    scrollToBottom(): void {
        try {
            this.scrollContainer.nativeElement.scrollTop =
                this.scrollContainer.nativeElement.scrollHeight;
        } catch { }
    }

    getChatResponse(quesId: string) {
        this.generatingReplyBool = true;
        let gettingResp = true;
        setTimeout(() => {
            if (gettingResp) {
                this.responseTimeout = true;
            }
        }, 60000);
        let documentChat: ChatType = ChatType.Normal;
        let documentsList = this.chatServices.getChatDocumentList();
        let UnstructuredDocs = 0;
        let StructuredDocs = 0;
        documentsList.forEach((e: IDocument) => {
            if (
                e.documentStatus === DocumentStatus.Processed &&
                (EXCEL_FILE_FORMATS.includes(e.contentType) ||
                    CSV_FILE_FORMATS.includes(e.contentType))
            ) {
                StructuredDocs += 1;
            } else if (
                (e.documentStatus === DocumentStatus.Processed || e.documentStatus === DocumentStatus.TextOnly) &&
                !(
                    EXCEL_FILE_FORMATS.includes(e.contentType) ||
                    CSV_FILE_FORMATS.includes(e.contentType)
                )
            ) {
                UnstructuredDocs += 1;
            }
        });
        if (StructuredDocs > 0 && UnstructuredDocs == 0) {
            documentChat = ChatType.StructuredDocument;
        } else if (UnstructuredDocs > 0 && StructuredDocs == 0) {
            documentChat = ChatType.UnstructuredDocument;
        } else if (UnstructuredDocs > 0 && StructuredDocs > 0) {
            documentChat = ChatType.StructuredUnstructuredDocs;
        }
        if (
            this.chatServices.chatType === ChatType.ESG &&
            this.activeChat?.chatTables?.length > 0 &&
            (this.activeChat.ESGTableTags.length > 0 ||
                this.activeChat.chatConfig?.ESGChat?.ESGSources?.length > 0 ||
                this.activeChat.chatConfig?.ESGChat?.ESGDocuments?.length > 0)
        ) {
            documentChat = ChatType.ESGStructuredUnstructuredDocs;
        }
        if (
            this.chatServices.chatType === ChatType.ESG &&
            this.activeChat?.chatTables?.length === 0 &&
            this.activeChat.ESGTableTags.length === 0 &&
            (this.activeChat.chatConfig?.ESGChat?.ESGSources?.length ?? 0) ===
                0 &&
            (this.activeChat.chatConfig?.ESGChat?.ESGDocuments?.length ?? 0) ===
                0
        ) {
            documentChat = ChatType.ESGStructuredUnstructuredDocs;
        }
        if ([ChatType.agenticWorkflow, ChatType.deepResearch].includes(this.chatServices.chatType)) {
            documentChat = this.chatServices.chatType;
        }
        
        this.isStructutredChat = !this.unStructuredChatTypes.includes(documentChat);
        if (
            this.activeChat?.chatType &&
            (this.activeChat?.chatType === ChatType.QEC ||
                (this.activeChat?.chatType === ChatType.ESG &&
                    this.activeChat?.chatTables?.length > 0 &&
                    documentChat !== ChatType.ESGStructuredUnstructuredDocs))
        ) {
            this.isStructutredChat = true;
        }

        let currentChatId = this.activeChat.chatId;

        let modelSelector = this.selectedModel;
        this.ChatResponseSub = this.chatServices
            .getQuestionResponse(
                this.activeChat.chatId,
                quesId,
                false,
                documentChat,
                modelSelector
            )
            .subscribe({
                next: (res: IChatInteraction) => {

                    if (
                        currentChatId == this.activeChat?.chatId &&
                        res.chatStatus === ChatStatus.Waiting
                    ) {
                        this.showTypeWriterResponse = true;
                    }
                    if (res.chatStatus === ChatStatus.Waiting) {
                        if (currentChatId == this.activeChat.chatId) {

                            this.chatMessages = this.chatMessages.map(
                                (chatMessage: IChatInteraction) => {
                                    if (chatMessage.interactionId == res.interactionId) {
                                        return res;
                                    }
                                    return chatMessage
                                }
                            );
                        }
                        if(this.chatServices.chatType === ChatType.deepResearch) {
                            this.chatLLMRespStatusUpdateDebounce.next({
                                quesID: quesId,
                                chatId: this.activeChat.chatId,
                                documentChat: documentChat,
                            });
                        } else {
                            this.chatRespUpdateDebounce.next({
                                quesID: quesId,
                                chatId: this.activeChat.chatId,
                                documentChat: documentChat,
                            });
                        }
                        
                    } else {
                        this.chatServices.emitCreateChat();
                        gettingResp = false;

                        if (currentChatId == this.activeChat?.chatId) {
                            this.chatMessages = this.chatMessages.map(
                                (chatMessage: IChatInteraction) => {
                                    if (chatMessage.interactionId == res.interactionId) {
                                        return res;
                                    }
                                    return chatMessage
                                }
                            );
                        }
                        let chatsAvailable = 0;
                        this.chatMessages.forEach((e) => {
                            if (e.interactionType === InteractionType.QA) {
                                this.showRegeneration = true;
                                chatsAvailable += 1;
                            }
                        })
                        setTimeout(() => {
                            this.chatServices.emitCreateChat(this.activeChat);
                            if (this.isNewChat || chatsAvailable === 1) {
                                this.chatServices.emitCreateChat();
                                this.isNewChat = false;
                            }
                            this.generatingReplyBool = false;
                            if (
                                this.chatServices.interactionType !==
                                    ChatType.StructuredUnstructuredDocs &&
                                this.chatServices.interactionType !==
                                    ChatType.ESGStructuredUnstructuredDocs &&
                                res.chatStatus === ChatStatus.Responded &&
                                res.response.at(-1)?.text
                            ) {
                                const resp = res.response.at(-1);
                                this.chatReply = resp?.text
                                this.reasoningSummary = resp?.responseEvents?.find(e => e.eventType === ChatResponseEventType.Reasoning)?.text;
                                this.progressSummary = resp?.responseEvents?.find(e => e.eventType === ChatResponseEventType.Progress)?.text;
                                this.generatingReplyBool = false;
                            }
                        }, 100);
                    }
                },
                error: (error) => {
                    this.generatingReplyBool = false;
                    gettingResp = false;

                    this.messageService.clear();
                    this.messageService.add({
                        severity: 'error',
                        summary: 'Error',
                        detail: error.error.message,
                    });
                },
            });
    }

    processCompletedLLMResponse(
        res: IChatInteraction,
        chatType: ChatType) {

        let currentChatId = this.activeChat.chatId;
        if (currentChatId == this.activeChat.chatId) {
            this.chatMessages = this.chatMessages.map((chatMessage) => {
                if (chatMessage.interactionId === res.interactionId) {
                    return res;
                }
                return chatMessage;
            })

            this.generatingReplyBool = false;
            if (chatType) {

                let chatsAvailabel = 0;
                this.chatMessages.forEach((e) => {
                    if (
                        e.interactionType === InteractionType.QA
                    ) {
                        this.showRegeneration = true;
                        chatsAvailabel += 1;
                    }
                });
            }
        }
        let chatsAvailabel = 0;
        this.chatMessages.forEach((e) => {
            if (e.interactionType === InteractionType.QA) {
                this.showRegeneration = true;
                chatsAvailabel += 1;
            }
        });
        setTimeout(() => {
            this.chatServices.emitCreateChat(this.activeChat);
            if (this.isNewChat || chatsAvailabel === 1) {
                this.chatServices.emitCreateChat();
                this.isNewChat = false;
            }
        }, 1000);
    }

    startPoll(questionId: string, chatType: ChatType){
        if (this.chatServices.chatType === ChatType.deepResearch) {
            this.chatLLMRespStatusUpdateDebounce.next({
                quesID: questionId,
                chatId: this.activeChat.chatId,
                documentChat: chatType,
            });
        } else {
            this.chatRespUpdateDebounce.next({
                quesID: questionId,
                chatId: this.activeChat.chatId,
                documentChat: chatType,
            });
        }
    }

    longPollChatInteractionById(
        chatId: string,
        interactionId: string,
        chatType: ChatType
    ) {
        let currentChatId = this.activeChat.chatId;
        this.ChatResponseSub = this.chatServices
            .getChatInteractionById(this.activeChat.chatId, interactionId)
            .subscribe({
                next: (res: IChatInteraction) => {
                    if (res.chatStatus === ChatStatus.Waiting) {
                         if (currentChatId == this.activeChat.chatId) {
                            this.chatMessages = this.chatMessages.map(
                                (chatMessage: IChatInteraction) => {
                                    if (chatMessage.interactionId == res.interactionId) {
                                        return res;
                                    }
                                    return chatMessage
                                }
                            );
                        }
                        this.chatRespUpdateDebounce.next({
                            quesID: interactionId,
                            chatId: chatId,
                            documentChat: chatType,
                        });
                    } else {
                        this.processCompletedLLMResponse(res, chatType);
                       
                    }
                },
                error: (error) => {
                    this.generatingReplyBool = false;
                    this.messageService.clear();
                    this.messageService.add({
                        severity: 'error',
                        summary: 'Error',
                        detail: error.error.message,
                    });
                },
            });
    }

    longPollLLMResponseStatus(chatId: string,
        interactionId: string,
        chatType: ChatType
    ) {
        let currentChatId = this.activeChat.chatId;
        this.ChatResponseSub = this.chatServices
            .checkStatusOfLLMInteraction(currentChatId, interactionId)
            .subscribe({
                next: (res: IChatInteraction) => {
                    if (res.chatStatus === ChatStatus.Waiting) {
                        const currentChatMessage = this.chatMessages.find(message => message.interactionId === interactionId);

                        if(currentChatMessage) {
                            const currentProgressSummary = currentChatMessage.response.at(-1)?.responseEvents?.find(event => event.eventType === ChatResponseEventType.Progress)?.text;
                            const responseProgressSummary = res.response.at(-1)?.responseEvents?.find(event => event.eventType === ChatResponseEventType.Progress)?.text;
                            if(currentProgressSummary?.length === 0 && responseProgressSummary?.length !== 0) {
                                currentChatMessage.response = res.response;
                            }
                        }
                        this.chatLLMRespStatusUpdateDebounce.next({
                            quesID: interactionId,
                            chatId: this.activeChat.chatId,
                            documentChat: chatType,
                        });
                        
                    } else {
                        this.setEditorEditableMode(true);
                        this.processCompletedLLMResponse(res, chatType);
                        
                    }
                },
                error: (error) => {
                    this.generatingReplyBool = false;
                    this.messageService.clear();
                    this.messageService.add({
                        severity: 'error',
                        summary: 'Error',
                        detail: error.error.message,
                    });
                },
            });
    }

    getChatInteractionsCount() {
        return this.chatMessages.length;
    }

    async regenerateResponse() {
        // ✅ REMOVED: Regeneration should NEVER change the prompt - always use the original prompt from when the chat started
        console.log(`Regenerating response - keeping original prompt, not syncing dropdown`);

        this.chatReply = '';
        this.reasoningSummary = '';
        this.progressSummary = '';
        this.generatingReplyBool = true;
        let interactionId: string;
        let userId: string;
        let chatMessagesIndex: number;
        this.showTypeWriterResponse = true;
        this.chatMessages.forEach((e: IChatInteraction, i: number) => {
            if (e.interactionType == InteractionType.QA) {
                interactionId = e.interactionId;
                userId = e.userId;
                chatMessagesIndex = i;
            }
        });
        // Ensure the regenerated interaction is the last item so streaming/typewriter UI targets it
        if (chatMessagesIndex !== undefined && chatMessagesIndex !== this.chatMessages.length - 1) {
            const [regenerated] = this.chatMessages.splice(chatMessagesIndex, 1);
            this.chatMessages.push(regenerated);
            chatMessagesIndex = this.chatMessages.length - 1;
        }

        this.chatMessages[chatMessagesIndex].response.push({
            text: '',
        });
        this.chatMessages[chatMessagesIndex].chatStatus = ChatStatus.Waiting;
        let documentChat: ChatType = ChatType.Normal;
        let documentsList = this.chatServices.getChatDocumentList();
        let UnstructuredDocs = 0;
        let StructuredDocs = 0;
        documentsList.forEach((e: IDocument) => {
            if (
                e.documentStatus === DocumentStatus.Processed &&
                (EXCEL_FILE_FORMATS.includes(e.contentType) ||
                    CSV_FILE_FORMATS.includes(e.contentType))
            ) {
                StructuredDocs += 1;
            } else if (
                (e.documentStatus === DocumentStatus.Processed || e.documentStatus === DocumentStatus.TextOnly) &&
                !(
                    EXCEL_FILE_FORMATS.includes(e.contentType) ||
                    CSV_FILE_FORMATS.includes(e.contentType)
                )
            ) {
                UnstructuredDocs += 1;
            }
        });
        if (StructuredDocs > 0 && UnstructuredDocs == 0) {
            documentChat = ChatType.StructuredDocument;
        } else if (UnstructuredDocs > 0 && StructuredDocs == 0) {
            documentChat = ChatType.UnstructuredDocument;
        } else if (UnstructuredDocs > 0 && StructuredDocs > 0) {
            documentChat = ChatType.StructuredUnstructuredDocs;
        }
        if (
            this.chatServices.chatType === ChatType.ESG &&
            this.activeChat?.chatTables?.length > 0 &&
            (this.activeChat.ESGTableTags.length > 0 ||
                this.activeChat.chatConfig?.ESGChat?.ESGSources?.length > 0 ||
                this.activeChat.chatConfig?.ESGChat?.ESGDocuments?.length > 0)
        ) {
            documentChat = ChatType.ESGStructuredUnstructuredDocs;
        }
        if (
            this.chatServices.chatType === ChatType.ESG &&
            this.activeChat?.chatTables?.length === 0 &&
            this.activeChat.ESGTableTags.length === 0 &&
            (this.activeChat.chatConfig?.ESGChat?.ESGSources?.length ?? 0) ===
                0 &&
            (this.activeChat.chatConfig?.ESGChat?.ESGDocuments?.length ?? 0) ===
                0
        ) {
            documentChat = ChatType.ESGStructuredUnstructuredDocs;
        }

         this.isStructutredChat = !this.unStructuredChatTypes.includes(documentChat)
        if (
            this.activeChat?.chatType &&
            (this.activeChat?.chatType === ChatType.QEC ||
                (this.activeChat?.chatType === ChatType.ESG &&
                    this.activeChat?.chatTables?.length > 0 &&
                    documentChat !== ChatType.ESGStructuredUnstructuredDocs))
        ) {
            this.isStructutredChat = true;
        }
        if (this.chatServices.chatType === ChatType.agenticWorkflow) {
            documentChat = ChatType.agenticWorkflow;
            this.isStructutredChat = false;
        }

        let modelSelectorRegenerate = this.selectedModel;
        // Join the WebSocket room immediately to avoid missing initial streamed tokens
        (async () => {
            try {
                if (await this.webSocketService?.isWebSocketConnected()) {
                    await this.webSocketService.connectAndJoinRoom(userId,interactionId);
                } else {
                    await this.connectToSocket();
                    await this.webSocketService.connectAndJoinRoom(userId, interactionId);
                }
            } catch (err) {
                console.log('Failed to join stream room on regenerate (pre-call):', err);
            }
        })();

        this.ChatResponseSub = this.chatServices
            .getQuestionResponse(
                this.activeChat.chatId,
                interactionId,
                true,
                documentChat,
                modelSelectorRegenerate
            )
            .subscribe({
                next: (res: IChatInteraction) => {
                    (async () => {
                        if (res.chatStatus === ChatStatus.Waiting) {
                            // Ensure we join the WS room for streaming on regenerate (e.g., Web Search)
                            if (res?.interactionId) {
                                if (await this.webSocketService?.isWebSocketConnected()) {
                                    try {
                                        await this.webSocketService.connectAndJoinRoom(res.userId, res.interactionId);
                                    } catch (err) {
                                        console.log('Failed to join stream on regenerate:', err);
                                    }
                                } else {
                                    await this.connectToSocket();
                                    try {
                                        await this.webSocketService.connectAndJoinRoom(res.userId, res.interactionId);
                                    } catch (err) {
                                        console.log('Failed to join stream after reconnect on regenerate:', err);
                                    }
                                }
                            }

                            this.chatMessages = this.chatMessages.map(
                                (chatMessage: IChatInteraction) => {
                                    if (chatMessage.interactionId == res.interactionId) {
                                        return res;
                                    }
                                    return chatMessage;
                                }
                            );
                            if(this.chatType === ChatType.deepResearch) {
                                this.chatLLMRespStatusUpdateDebounce.next({
                                    quesID: interactionId,
                                    chatId: this.activeChat.chatId,
                                    documentChat: documentChat,
                                });
                            } else {
                                this.chatRespUpdateDebounce.next({
                                    quesID: interactionId,
                                    chatId: this.activeChat.chatId,
                                    documentChat: documentChat,
                                });
                            }
                        } else {
                            if (
                                this.chatServices.interactionType !==
                                    ChatType.StructuredUnstructuredDocs &&
                                this.chatServices.interactionType !==
                                    ChatType.ESGStructuredUnstructuredDocs &&
                                res.chatStatus === ChatStatus.Responded
                            ) {
                                const resp = res.response?.at(-1);
                                this.chatReply = resp?.text
                                this.reasoningSummary = resp?.responseEvents?.find(e => e.eventType === ChatResponseEventType.Reasoning)?.text;
                                this.progressSummary = resp?.responseEvents?.find(e => e.eventType === ChatResponseEventType.Progress)?.text;
                            }
                            this.chatMessages = this.chatMessages.map(chatMessage => {
                                if (chatMessage.interactionId == res.interactionId) {
                                    return res;
                                }
                                return chatMessage;
                            })
                            
                            this.showTypeWriterResponse = false;
                            this.chatServices.emitCreateChat(this.activeChat);

                            this.generatingReplyBool = false;
                        }
                    })();
                    
                },
                error: (error) => {
                    this.messageService.clear();
                    this.messageService.add({
                        severity: 'error',
                        summary: 'Error',
                        detail: error.error.message,
                    });
                    this.generatingReplyBool = false;
                    this.chatMessages[chatMessagesIndex].response.pop();
                },
            });
    }

    isActiveChat() {
        return (
            !this.activeChat?.chatState ||
            (this.activeChat.chatState !== ChatState.InActive &&
                this.activeChat.chatState !== ChatState.Archived)
        );
    }

    checkSubmit(event: any) {
        if (
            event.key === 'Enter' &&
            !this.showToolbar &&
            !this.generatingReplyBool &&
            !event.shiftKey &&
            this.processedInputText() &&
            this.processedInputText().trim() != '' &&
            this.isActiveChat()
        ) {
            if (
                this.chatServices.getChatType() === ChatType.QEC &&
                ((this.activeChat?.chatId && !this.activeChat?.chatTables?.length) ||
                    (!this.activeChat?.chatId && this.docService.defaultWFDOTables.length === 0)
                )
            ) {
                return;
            } else {
                event.preventDefault();
                this.generatingReplyBool = true;
                this.onQuestionSubmit();
            }
        }
    }

    private escapeHtml(s: string): string {
    return s
        .replaceAll('&', '&amp;')
        .replaceAll('<', '&lt;')
        .replaceAll('>', '&gt;');
    }

    private insertHtmlAtCursor(html: string) {
        const editorDiv = this.editorElementRef?.textArea?.nativeElement as HTMLElement;
        if (!editorDiv) return;

        editorDiv.focus();
        const sel = globalThis.getSelection();
        if (!sel) return;

        // Ensure selection is inside editor
        if (sel.rangeCount === 0 || !editorDiv.contains(sel.anchorNode)) {
            const range = document.createRange();
            range.selectNodeContents(editorDiv);
            range.collapse(false);
            sel.removeAllRanges();
            sel.addRange(range);
        }

        let range = sel.getRangeAt(0);

        // --- Collapse duplicate <br>’s around caret (left side) ---
        const left = range.startContainer.nodeType === Node.TEXT_NODE
            ? range.startContainer
            : range.startContainer.childNodes[range.startOffset - 1] || range.startContainer.childNodes[range.startOffset];

        const removeConsecutiveBR = (node: Node | null) => {
            if (!node) return;
            // remove any immediate sequence of BRs on left
            let n = (node as any).previousSibling;
            while (n?.nodeName === 'BR' && n?.previousSibling?.nodeName === 'BR') {
            const toRemove = n.previousSibling as ChildNode;
            toRemove?.remove();
            n = (node as any).previousSibling;
            }
        };
        removeConsecutiveBR(left);

        // Insert HTML fragment
        const frag = range.createContextualFragment(html);
        range.deleteContents();
        range.insertNode(frag);

        // Move caret to end of inserted content
        range = document.createRange();
        range.selectNodeContents(editorDiv);
        range.collapse(false);
        sel.removeAllRanges();
        sel.addRange(range);

        // Notify angular-editor
        editorDiv.dispatchEvent(new Event('input', { bubbles: true }));
    }


    onPaste(event: ClipboardEvent) {
        const dt = event.clipboardData;
        if (!dt) return;

        if(!this.editorConfig.editable){
            return;
        }

        const items = Array.from(dt.items || []);
        const imageItems = items.filter(i => i.kind === 'file' && i.type?.startsWith('image/'));
        const fileItems  = items.filter(i => i.kind === 'file');
        const html = dt.getData('text/html') || '';
        const text = dt.getData('text/plain') || '';

        // If clipboard has file(s) but none are images, block & warn
        if (fileItems.length > 0 && imageItems.length === 0) {
            event.preventDefault();
            event.stopPropagation();

            // In Chrome/Edge, non-image files often have empty MIME type ('')
            // Treat anything that's not image/* as unsupported here
            this.messageService.clear();
            this.messageService.add({
            severity: 'warn',
            summary: 'File Type',
            detail: 'Only .png/ .jpg/ .jpeg/ .gif/ .bmp/ .tiff/ .webp files are allowed',
            });
            return;
        }
        
        // "Meaningful" text exists if plain text is non-empty OR HTML (without <img>) has non-whitespace
        const htmlWithoutImg = html.replaceAll(/<img[\s\S]*?>/gi, '').trim();
        const hasMeaningfulText = (text.trim().length > 0) || (htmlWithoutImg.length > 0);

        // === CASE 1: Image-only paste (typical PrintScreen paste) ===
        if (imageItems.length > 0 && !hasMeaningfulText) {
            event.preventDefault();
            event.stopPropagation();

            // Enforce one image per question
            if (this.filesUploaded.length > 0) {
                this.messageService.clear();
                this.messageService.add({
                    severity: 'warn',
                    summary: 'Warning',
                    detail: 'You can only attach one image per question. To add another, please attach it in your next question.',
                });
                return;
            }

            if (imageItems.length > 1) {
                this.messageService.clear();
                this.messageService.add({
                    severity: 'warn',
                    summary: 'Multiple images',
                    detail: 'Multiple images detected from clipboard. Only one will be used.'
                });
            }

            const file = imageItems[0].getAsFile();
            if (!file) return;

            // Model/chat constraints
            if (this.selectedModel.featuresSupported?.imageUpload === false) {
                this.messageService.clear();
                this.messageService.add({
                    severity: 'error',
                    summary: 'Error',
                    detail: 'Image is not supported for the selected Model.'
                });
                return;
            }
            if (
            this.chatType === ChatType.codeInterpreter ||
            this.chatType === ChatType.QEC ||
            this.chatType === ChatType.ESG ||
            this.chatType === ChatType.quilt ||
            ((this.chatServices.getChatDocumentList()?.length ?? 0)) > 0
            ) {
                this.messageService.clear();
                this.messageService.add({
                    severity: 'error',
                    summary: 'Error',
                    detail: 'Image upload not permitted in this chat.'
                });
                return;
            }

            // --- De-dupe: ignore if identical to last clipboard image within 3 seconds ---
            const sig = `${file.size}:${file.type}:${file.lastModified}`;
            const now = Date.now();
            if (this._lastPasteSig === sig && (now - this._lastPasteAt) < 3000) {
                // Same image pasted again quickly -> ignore
                return;
            }
            this._lastPasteSig = sig;
            this._lastPasteAt = now;

            // Proceed with our existing path
            this.processFiles([file]);
            return;
        }

        // === CASE 2: Text and/or HTML present (possibly with <img>) -> strip images, keep text ===
        event.preventDefault();
        event.stopPropagation();

        let plain = '';
        if (html) {
            plain = htmlToText(html, {
            wordwrap: false,
            preserveNewlines: true,
            selectors: [
                { selector: 'img', format: 'skip' },
                { selector: 'script', format: 'skip' },
            ],
            });
        } else {
            plain = text || '';
        }

        // Normalize newlines
        plain = plain.replaceAll('\r\n', '\n');

        // Strip leading/trailing blank lines (this is where the stray <br> often comes from)
        plain = plain.replaceAll(/^\s*\n+/g, '').replaceAll(/\n+\s*$/g, '');

        // Optional: collapse >2 consecutive newlines to exactly 2
        plain = plain.replaceAll(/\n{3,}/g, '\n\n');

        // Build safe HTML without leading/trailing <br>
        const htmlWithBreaks = plain.includes('\n')
            ? this.escapeHtml(plain).replaceAll('\n', '<br>')
            : this.escapeHtml(plain);

        // Insert at caret (instead of overwriting the whole model)
        this.insertHtmlAtCursor(htmlWithBreaks);

        if (imageItems.length > 0) {
            this.messageService.clear();
            this.messageService.add({
            severity: 'warn',
            summary: 'Images removed',
            detail: 'Images were stripped from the paste. You can only chat with one image at a time.'
            });
        }
    }


    ngOnDestroy() {
        this.getchatInteractionsSub?.unsubscribe();
        this.createChatSub?.unsubscribe();
        this.ChatResponseSub?.unsubscribe();
        this.fileUploadSub?.unsubscribe();
        this.chatRespDebounceSubscription?.unsubscribe();
        this.chatLLMRespStatusDebounceSubscription?.unsubscribe();
        this.chatReplySubscription?.unsubscribe();
        this.chatSelectedSub?.unsubscribe();
        this.removeFile(null, true);
        this.revokeAllImageURLs();
        this.updateChatsSub?.unsubscribe();
        this.userStateSub?.unsubscribe();
        this.chatTypeObsSub?.unsubscribe();
    }

    async connectToWSRoom(userId: string, interactionId: string, retryConnection = false) {
        try {
            await this.webSocketService.connectAndJoinRoom(
                userId,
                interactionId
            );
        } catch (error) {
            if(retryConnection) {
                await this.connectToSocket();
                await this.connectToWSRoom(userId, interactionId);
            } else {
                console.log(
                    'Error connecting to WebSocket:',
                    error
                );
            }
        }
    }

    /**
     * Update the UI and dropdown to reflect the selected chat's prompt template.
     * Handles missing prompt templates and ensures dropdown is always in sync.
     * This function is invoked on chat selection in sidebar (called using Output Event)
     */
    updateChat(option: Object) {
        let selectedChatId = option['activeChat']?.chatId;
        const currentChatType = this.chatType;
        this.chatDocuments?.pollingSet?.clear();
        this.chatDocuments.CSVFiles = [];
        this.updateModelAppearance(selectedChatId);
        this.generatingReplyBool = false;
        if (currentChatType === ChatType.QEC || currentChatType === ChatType.ESG) {
            this.inputText = null;
        }
        this.showTypeWriterResponse = false;
        this.chatReply = '';
        this.reasoningSummary = '';
        this.progressSummary = '';
        this.memoryToggle =false
        this.chatServices.memoryChat = this.memoryToggle;
        this.revokeAllImageURLs();
        this.removeFile(null, true);
        this.chatPeriod = option['period'] ? option['period'] : 'Today';

        if (this.getchatInteractionsSub) {
            this.getchatInteractionsSub.unsubscribe();
            this.getchatInteractionsSub = new Subscription();
        }

        // Chat selection changed(or new empty chat initiated)
        this.router.navigate(['/chat', getRouteParamChatType(currentChatType), selectedChatId ?? 'new']);

        if (option['type'] == 'updateChat') {
            this.activeChat = option['activeChat'];
            this.chatServices.updateActiveChatObs(this.activeChat);
            this.chatServices.updateActiveChat(this.activeChat);
            this.updateReasoningModeAppearance()

            // --- Prompt dropdown sync logic ---
            // Find the prompt template for this chat, or fallback to default
            if (this.activeChat?.activePromptTemplate) {
                const found = this.promptTemplates.find(
                    t => t.name === this.activeChat.activePromptTemplate
                );
                this.selectedPromptTemplate =
                    found ||
                    this.promptTemplates.find(t => t.name === 'Default') ||
                    this.promptTemplates[0];
            } else {
                // If no prompt set for this chat, fallback to default and warn
                this.selectedPromptTemplate =
                    this.promptTemplates.find(t => t.name === 'Default') ||
                    this.promptTemplates[0];
            }
            this.chatServices.setPromptTemplateSelection(this.selectedPromptTemplate);

            this.loadingChats = true;
            this.getChatInteractions();
            if (option['interaction']) {
                let element;
                let interaction = option['interaction'];
                this.interactionContainer.forEach((elRef) => {
                    if (
                        elRef.nativeElement.dataset['id'] ===
                        interaction.interactionId
                    ) {
                        element = elRef;
                        element.nativeElement.scrollIntoView({
                            behavior: 'smooth',
                            block: 'start',
                        });
                    }
                });
            }
        } else {
            this.chatMessages = [];
            this.activeChat = this.chatServices.getActiveChat();
            this.chatServices.updateChatDocumentList([]);

            if (!this.activeChat?.chatId) {
                this.loadingChats = false;
            }
            if (!this.activeChat) {
                this.getChatDocumentsLoader = false;
            }
        }

        const inputtextbox = document.querySelectorAll('.inputtextbox');
        inputtextbox.forEach((elem: Element) => {
            let additionalMargin = 48;
            (elem as HTMLElement).style.height = `${additionalMargin}px`;
        });
        this.autoFocusInputBox();
    }

    checkDocSummary(text: string) {
        if (text && text === 'summary') {
            this.generatingReplyBool = true;
            this.getChatInteractions();
        }
        if( text && text === 'loadChatHistory') {
          this.chatServices.emitCreateChat();
            return ;
        }
        if (text && text === 'showLoader') {
            this.getChatDocumentsLoader = true;
        } else {
            this.getChatDocumentsLoader = false;
        }
    }

    setEditorEditableMode(editable: boolean) {
        this.editorConfig = { ...this.editorConfig, editable };
    }

    getChatInteractions() {
        this.activeChat ??= this.chatServices.getActiveChat();
        if (!this.activeChat) {
            this.loadingChats = false;
        }
        this.getchatInteractionsSub = this.chatServices
            .getChatInteractions(this.activeChat?.chatId)
            .subscribe({
                next: (res: IChatInteraction[]) => {
                    this.loadingChats = false;
                    this.chatMessages = res;
                    this.syncMemoryChatAvailability();
                    this.interactionsemit.emit(this.chatMessages.length);
                    this.showRegeneration = false;
                    for (let chatMessage of this.chatMessages) {
                        if (chatMessage.request?.images?.length > 0) {
                            this.getRequestImages(
                                chatMessage.request.images,
                                chatMessage.interactionId
                            );
                        }
                        if (chatMessage.interactionType === InteractionType.QA) {
                            this.showRegeneration = true;
                        }
                    }

                    const lastMessage = this.chatMessages.at(-1);

                    if (
                        lastMessage?.response?.length == 0
                    ) {
                        this.responseTimeout = true;
                    }
                    this.setEditorEditableMode(true);

                    const chatTypesToPoll: ChatType[] = [ChatType.deepResearch, ChatType.quilt]
                    if (lastMessage.chatStatus === ChatStatus.Waiting && chatTypesToPoll.includes(this.chatType)) {
                        this.generatingReplyBool = true;
                        this.showTypeWriterResponse = true;
                        this.setEditorEditableMode(false);
                        if ((lastMessage.request.requestId && this.chatType === this.deepResearchChatType) ||
                            (this.chatType === this.quiltChatType)) {
                            this.startPoll(lastMessage.interactionId, this.chatType)
                        }

                        this.connectToWSRoom(lastMessage.userId, lastMessage.interactionId, true);
                    }

                    let pollingSetcount = this.chatDocuments?.pollingSet?.size || 0;

                    if (this.chatDocuments?.pollingSet?.size > 0) {
                      for (const e of this.chatDocuments.pollingSet) {
                        const document = this.chatDocuments.documentsList.find(
                          (doc) => doc.documentId === e
                        );

                       if (document?.documentStatus === DocumentStatus.TextOnly) {
                        pollingSetcount -= 1;
                      }
                    }
                  }

                    if (pollingSetcount === 0 && this.chatType !== ChatType.deepResearch) {
                      this.generatingReplyBool = false;
                    }

                    setTimeout(() => {
                        this.scrollToBottom();
                    }, 50);
                },
                error: (error) => {
                    this.loadingChats = false;
                    this.messageService.clear();
                    this.messageService.add({
                        severity: 'error',
                        summary: 'Error',
                        detail: error.error.message,
                    });
                },
            });
       
    }

    getChatDocuments() {
        this.activeChat ??= this.chatServices.getActiveChat();
        this.getChatDocsSub = this.chatServices
            .getChatDocuments(this.activeChat.chatId)
            .subscribe({
                next: (res: IChatDocument[]) => {
                    this.activeChat.chatDocument = res;
                    this.chatServices.updateActiveChatObs(this.activeChat);
                    this.chatServices.updateActiveChat(this.activeChat);
                    this.syncMemoryChatAvailability();
                },
            });
    }

    attachDeltaTablesToChat(chatId: string, chatTables: IDeltaTable[]) {
        this.chatServices
            .updateChatDocuments([],
                chatId,
                chatTables
            )
            .subscribe({
                next: (res) => {
                    this.activeChat = res?.data;
                    this.chatServices.updateActiveChatObs(res?.data);
                    this.chatServices.updateActiveChat(res?.data);

                    if (res?.message?.trim() != '') {
                        this.messageService.clear();
                        this.messageService.add({
                            severity: 'error',
                            summary: 'Error',
                            detail: res?.message,
                        });
                    }

                    this.sendMessage();
                },
                error: (error) => {
                    this.messageService.clear();
                    this.messageService.add({
                        severity: 'error',
                        summary: 'Error',
                        detail: error.error.message,
                    });
                },
            })
    }

    /**
     * Create a new chat, passing the selected prompt template for atomic assignment.
     * Ensures error handling for missing prompt and backend sync issues.
     */
    createNewChat() {
        // Use the selected prompt template, or fallback to service selection, or null
        const promptTemplate =
            this.selectedPromptTemplate ||
            this.chatServices.getPromptTemplateSelection() ||
            null;

        if (!promptTemplate?.name) {
            this.messageService.clear();
            this.messageService.add({
                severity: 'error',
                summary: 'Prompt Error',
                detail: 'No prompt template selected. Please select a prompt before creating a chat.',
            });
            this.generatingReplyBool = false;
            return;
        }

        // Ensure the selected model is set in the service so it is sent to the backend
        this.chatServices.setModelSelection(this.selectedModel);

        this.createChatSub = this.chatServices.createNewChat(promptTemplate).subscribe({
            next: (res: IChat) => {
                this.activeChat = res;
                this.isNewChat = true;
                // Ensure dropdown reflects the chat's prompt
                if (this.activeChat?.activePromptTemplate) {
                    const found = this.promptTemplates.find(
                        t => t.name === this.activeChat.activePromptTemplate
                    );
                    this.selectedPromptTemplate =
                        found ||
                        this.promptTemplates.find(t => t.name === 'Default') ||
                        this.promptTemplates[0];
                }
                this.chatServices.setPromptTemplateSelection(this.selectedPromptTemplate);

                // New chat created, update window URL
                this.router.navigate(['/chat', getRouteParamChatType(this.chatType), this.activeChat.chatId]);

                if (this.chatType === ChatType.QEC && this.docService.defaultWFDOTables.length) {
                    const chatId = this.activeChat.chatId;
                    this.attachDeltaTablesToChat(chatId, this.docService.defaultWFDOTables);
                    return;
                }


                this.chatServices.updateActiveChatObs(this.activeChat);
                this.chatServices.updateActiveChat(this.activeChat);
                this.sendMessage();
            },
            error: (error) => {
                this.chatMessages = [];
                this.generatingReplyBool = false;
                this.messageService.clear();
                this.messageService.add({
                    severity: 'error',
                    summary: 'Chat Creation Error',
                    detail:
                        (error?.error?.message || error?.message) ??
                        'Failed to create chat. Please try again.',
                });
            },
        });
    }

    toggleToolbar() {
        this.showToolbar = !this.showToolbar;
        this.editorConfig.showToolbar = this.showToolbar;
    }

    processedInputText() {
        const turndownService = new TurndownService();
        return turndownService.turndown(this.inputText);
    }

    async onUploadFiles(event: Event) {
        event.preventDefault();
        event.stopPropagation();
        const inputElement = event.target as HTMLInputElement;
        if (inputElement.files && inputElement.files.length > 0) {
            let temp_files = Array.from(inputElement.files);
            await this.processFiles(temp_files);
            inputElement.value = '';
        }
    }

    async onUploadFilesDragDrop(event: DragEvent) {
        event.preventDefault();
        event.stopPropagation();
        const dt = event.dataTransfer;
        const inputElement = dt as unknown as HTMLInputElement;
        if (inputElement.files && inputElement.files.length > 0) {
            let temp_files = Array.from(inputElement.files);
            await this.processFiles(temp_files);
            inputElement.value = '';
        }

    }


    async onFIleuploadForDocChat(event:Event){
      event.preventDefault();
      event.stopPropagation();
      this.chatDocuments.fileSelect(event)
      this.syncMemoryChatAvailability();
      this.fileUpload.nativeElement.value = ''
      this.fileUploadDocMainInput.nativeElement.value = ''
    }

    async onFIleuploadForDocChatOnDrag(event:DragEvent){
      event.preventDefault();
      event.stopPropagation();
      this.chatDocuments.fileSelectOnDrag(event)
      this.syncMemoryChatAvailability();
      this.fileUpload.nativeElement.value = ''
      this.fileUploadDocMainInput.nativeElement.value = ''
    }

    async processFiles(files: File[]) {
        this.filesUploaded = [];
        for (let file of files) {
            if (ALL_IMAGE_FILE_FORMATS.includes(file.type)) {
                this.filesUploaded.push(file);
                this.filesUploadedImgUrls.push({
                    url: this.getSafeUrl(file),
                    loading: false,
                });
                this.syncMemoryChatAvailability();
                this.autoFocusInputBox();
            } else {
                this.messageService.clear();
                this.messageService.add({
                    severity: 'warn',
                    summary: 'File Type',
                    detail: 'Only .png/ .jpg/ .jpeg/ .gif/ .bmp/ .tiff/ .webp files are allowed',
                });
            }
        }
    }

    async sendFileQuestion(questionText: string, interactionType: InteractionType) {
        // ✅ CRITICAL FIX: Only sync prompt on INITIAL file message (when no existing interactions)
        const isInitialMessage = !this.chatMessages || this.chatMessages.length === 0;
        if (isInitialMessage && this.selectedPromptTemplate?.name) {
            const chatId = this.activeChat?.chatId;
            console.log(`Initial file message - syncing backend prompt to dropdown selection: ${this.selectedPromptTemplate.name}, chatId: ${chatId}`);
            
            try {
                await lastValueFrom(this.promptService.setActivePromptForUser(this.selectedPromptTemplate.name, chatId));
                console.log(`Successfully synced initial file prompt to: ${this.selectedPromptTemplate.name}`);
                
                // Update the active chat's activePromptTemplate if there's an active chat
                if (this.activeChat && chatId) {
                    this.activeChat.activePromptTemplate = this.selectedPromptTemplate.name;
                }
            } catch (error) {
                console.error(`Failed to sync initial file prompt selection:`, error);
                // Continue with message sending even if prompt sync fails
            }
        } else if (!isInitialMessage) {
            console.log(`Existing chat with ${this.chatMessages?.length} messages - keeping existing prompt for file upload`);
        }

        if (this.activeChat?.chatId) {
            const formData = new FormData();
            formData.append('questionText', questionText);
            formData.append('chatID', this.activeChat.chatId);
            formData.append('interactionType', interactionType);
            this.filesUploaded.forEach((e: File) => {
                formData.append('images', e);
            });
            this.fileUploadSub.add(
                this.chatServices
                    .sendFileQuestion(formData, this.activeChat.chatId)
                    .subscribe({
                        next: (res: IChatInteraction) => {
                            (async () => {
                                if (await this.webSocketService?.isWebSocketConnected()) {
                                    if (res.interactionId) {
                                        try {
                                            await this.webSocketService.connectAndJoinRoom(res.userId, res.interactionId);
                                        } catch (error) {
                                            console.log('Failed to stream response:', error);
                                        }
                                    }
                                    if (res.request?.images?.length > 0) {
                                        this.getRequestImages(
                                            res.request.images,
                                            res.interactionId
                                        );
                                    }
                                    this.autoFocusInputBox();
                                    this.removeFile(null, true);
                                    this.chatReply = '';
                                    this.reasoningSummary = '';
                                    this.progressSummary = '';
                                    this.currentChatRequest = res.request;
                                    this.inputText = null;
                                    this.showTypeWriterResponse = true;
                                    this.chatMessages.push(res);
                                    this.interactionsemit.emit(
                                        this.chatMessages.length
                                    );
                                    setTimeout(() => {
                                        this.scrollToBottom();
                                    }, 50);
                                    this.getChatResponse(res['interactionId']);
                                    this.sendQuestionLoader = false;
                                }
                                else {
                                    await this.connectToSocket();
                                    this.sendFileQuestion(questionText, interactionType);
                                }
                            })();

                        },
                        error: (error) => {
                            this.messageService.clear();
                            this.messageService.add({
                                severity: 'error',
                                summary: 'Error',
                                detail: error.error.message,
                            });
                        }
                    }
                    )
            );
        } else {
            this.createNewChat();
        }
    }

    getSafeUrl(file: File): SafeUrl {
        const url = URL.createObjectURL(file);
        return this.sanitizer.bypassSecurityTrustUrl(url);
    }

    removeFile(index?: number, clearAll?: boolean): void {
        if (index !== undefined && index !== null) {
            URL.revokeObjectURL(this.filesUploadedImgUrls[index].url as string);
            this.filesUploaded.splice(index, 1);
            this.filesUploadedImgUrls.splice(index, 1);
        }
        if (clearAll) {
            this.filesUploaded = [];
            for(let file of this.filesUploadedImgUrls) {
                URL.revokeObjectURL(file.url as string);
            }
            this.filesUploadedImgUrls = [];
        }
    }

    getRequestImages(uuidImageName: IImagesRequest[], interactionId: string) {
        if (
            !this.currentQuestionImages[interactionId] ||
            Object.keys(this.currentQuestionImages[interactionId])?.length == 0
        ) {
            this.currentQuestionImages[interactionId] = {};
            uuidImageName.forEach((e: IImagesRequest, index: number) => {
                this.currentQuestionImages[interactionId][e.imageName] = {
                    imageURL: '',
                    loading: true,
                };
            });
            uuidImageName.forEach((e: IImagesRequest, index: number) => {
                this.chatServices
                    .getChatImage(this.activeChat.chatId, e.imageName)
                    .subscribe({
                        next: (res: ArrayBuffer) => {
                            if (res) {
                                const bufferData = new Uint8Array(res['data']);
                                const blob = new Blob([bufferData], {
                                    type: 'image/png',
                                });
                                const updatedImages = {
                                    ...this.currentQuestionImages[
                                        interactionId
                                    ],
                                };
                                updatedImages[e.imageName] = {
                                    imageURL:
                                        this.sanitizer.bypassSecurityTrustUrl(
                                            URL.createObjectURL(blob)
                                        ),
                                    loading: false,
                                };
                                this.currentQuestionImages[interactionId] =
                                    updatedImages;
                                setTimeout(() => {
                                    this.scrollToBottom();
                                }, 1000);
                            }
                        },
                        error(err) {},
                    });
            });
        }
    }

    revokeAllImageURLs() {
        for (const interactionId in this.currentQuestionImages) {
            if (this.currentQuestionImages.hasOwnProperty(interactionId)) {
                const images = this.currentQuestionImages[interactionId];
                for (const imageName in images) {
                    if (images.hasOwnProperty(imageName)) {
                        const imageObject = images[imageName];
                        if (
                            imageObject.imageURL &&
                            typeof imageObject.imageURL
                                .changingThisBreaksApplicationSecurity ===
                                'string'
                        ) {
                            const url =
                                imageObject.imageURL
                                    .changingThisBreaksApplicationSecurity;
                            URL.revokeObjectURL(url);
                        }
                    }
                }
            }
        }
        this.currentQuestionImages = {};
    }

    stopLongpollInteraction() {
        if (this.chatRespDebounceSubscription) {
            this.chatRespDebounceSubscription.unsubscribe();
            this.chatRespDebounceSubscription = new Subscription();
        }
        if(this.chatLLMRespStatusDebounceSubscription) {
            this.chatLLMRespStatusDebounceSubscription.unsubscribe();
            this.chatLLMRespStatusDebounceSubscription = new Subscription();

        }
    }

    stopGeneration() {
        // Always stop polling and subscriptions first
        const index = this.chatMessages.length - 1;
        const lastInteraction = { ...this.chatMessages[index] };

        // Quilt Chat for now
        if(this.chatServices.getChatType() !== ChatType.quilt) {
            return;
        }

        // Can't cancel Generation if Insteraction Id is not created yet.
        if(lastInteraction?.chatStatus !== ChatStatus.Waiting) {
            return;
        }

        this.stopLongpollInteraction();
        this.cancelChatInteractionResponse();
        
        
        if (index >= 0) {
            const cancelledText = this.chatReply?.trim() || 'Action cancelled by user';
            
            // Create a new interaction object to trigger Angular change detection
            
            if (lastInteraction.response?.length > 0) {
                const msgIndex = lastInteraction.response.length - 1;
                lastInteraction.response = [...lastInteraction.response];
                lastInteraction.response[msgIndex] = {
                    ...lastInteraction.response[msgIndex],
                    text: cancelledText
                };
            } else {
                lastInteraction.response = [{
                    text: cancelledText
                }];
            }
            lastInteraction.chatStatus = ChatStatus.Responded;
            
            // Replace the interaction in the array to trigger change detection
            this.chatMessages = [
                ...this.chatMessages.slice(0, index),
                lastInteraction
            ];
            
        }
        
        this.isStructutredChat = false;
        // Clear state after updating the message
        this.chatReply = '';
        this.reasoningSummary = '';
        this.progressSummary = '';
        this.generatingReplyBool = false;
        this.showTypeWriterResponse = false;
        
        this.initializeDebounceSubscription();
        if(lastInteraction.interactionId) {
            this.chatServices.cancelGeneration(this.activeChat.chatId, lastInteraction.interactionId)
                .subscribe({
                    error: (err) => {
                        console.error('Failed to cancel generation', err);
                    }
                });
        }
        this.setEditorEditableMode(true);
        
    }

    //SearchDocuments

    showDocuments() {
      switch (this.chatServices.getChatType()) {
        case ChatType.Normal:
          this.showSearchDocumentsBool = true;
          break;
        case ChatType.QEC:
          this.showQECDocumentsBool = true;
          break;
        case ChatType.ESG:
          this.showESGDocumentsBool = true;
          break;
        default:
          break;
      }
    }

    onDialogClose(event: boolean) {
      switch(this.chatServices.getChatType())
      {
        case ChatType.Normal:
          this.showSearchDocumentsBool = event;
          break;
        case ChatType.QEC:
          this.showQECDocumentsBool = event;
          break;
        case ChatType.ESG:
          this.showESGDocumentsBool = event;
          break;
        default:
          break;
      }
    }

    // ESG FILTERS

deleteChatESGDocs(document:ISourceURL, idx:number){
  this.ESGDocumentLoaderDocs[idx]= true
  const ESGFilter :Record<string,any> ={}
  if(this.activeChat?.chatConfig?.ESGChat){
      const deletionSource = document.sourceType
      let countSourceTypeDocs = 0
      let updatedDocs:ISourceURL[] = []
      this.activeChat.chatConfig?.ESGChat?.ESGDocuments.map((e:ISourceURL)=>{
        if(e.sourceType === deletionSource){
          countSourceTypeDocs +=1
        }
        if(document.documentPath !== e.documentPath){
          updatedDocs.push(e)
        }
      })
      if(countSourceTypeDocs==1){
        ESGFilter['SourceType'] = this.activeChat.chatConfig?.ESGChat?.ESGSources?.filter(e=>e.sourceType !== deletionSource)
      }else{
        ESGFilter['SourceType'] = this.activeChat.chatConfig?.ESGChat?.ESGSources
      }
      ESGFilter['DocumentName'] = updatedDocs
      ESGFilter['Tags'] = this.activeChat.ESGTableTags
      this.updateESGFilters(ESGFilter, true)
  }
}

deleteESGTags(tag:ITableTag, idx:number){
  this.ESGDeletionLoaderTags[idx]= true
  const ESGFilter :Record<string,any> ={
    'Tags' : this.activeChat?.ESGTableTags?.filter(e=>e!=tag),
  }
  if(this.activeChat?.chatConfig?.ESGChat){
    ESGFilter['SourceType'] = this.activeChat.chatConfig?.ESGChat?.ESGSources
    ESGFilter['DocumentName'] = this.activeChat.chatConfig?.ESGChat?.ESGDocuments
  }
  this.updateESGFilters(ESGFilter, true)
}

deleteESGSources(source:ISourceURL, idx:number){
  this.ESGDeletionLoaderSources[idx]= true
  const ESGFilter :Record<string,any> ={
    'Tags' : this.activeChat?.ESGTableTags || [],
  }
  if(this.activeChat?.chatConfig?.ESGChat){
    ESGFilter['SourceType'] = this.activeChat.chatConfig?.ESGChat?.ESGSources.filter(e=>e.sourceType!=source.sourceType)
    ESGFilter['DocumentName'] = this.activeChat.chatConfig?.ESGChat?.ESGDocuments.filter(e=>e.sourceType !== source.sourceType)
  }
  this.updateESGFilters(ESGFilter, true)
}


  async updateESGFilters(event:any,hideloading?:boolean){
    if(!hideloading){
      this.loadingChats = true
    }
    let selectedTags :ITableTag[] = event.Tags || []
    let selectedTables :IDeltaTable[] = event.deltaTables || []
    let chatConfig: IChatConfig = {}
    if(event.SourceType || event.DocumentName){
      let tempESGConfig:IESGConfig = {
        ESGSources : event.SourceType || [],
        ESGDocuments : event.DocumentName || []
      }
      chatConfig.ESGChat =tempESGConfig
    }
    if(this.activeChat?.chatId){
      this.updateChatsSub.add(
          this.chatServices
              .updateChatDocuments(
                  [],
                  this.activeChat.chatId,selectedTables,selectedTags,chatConfig
              )
              .subscribe({
                  next: (res:IAddDoctoChatAPIResp) => {
                    this.activeChat = res.data
                    this.ESGDocumentLoaderDocs = {}
                    this.ESGDeletionLoaderTags = {}
                    this.ESGDeletionLoaderSources = {}
                    this.chatServices.updateActiveChatObs(res.data);
                    this.chatServices.updateActiveChat(this.activeChat);
                    // Ensure model and prompt dropdowns are synced after document update
                    this.syncDropdownsToActiveChat();
                    this.loadingChats=false
                  },
                  error: (error) => {
                          this.loadingChats=false
                          this.messageService.clear();
                          this.messageService.add({
                              severity: 'error',
                              summary: 'Error',
                              detail: error.error.message,
                          });
                  },
              })
      );}else{
        this.createChatSub.add(
          this.chatServices.createNewChat().subscribe({
              next: (res: IChat) => {
                  this.activeChat = res;
                  this.updateESGFilters(event)
              },
              error: (error) => {
                this.loadingChats=false
                  this.messageService.clear();
                  this.messageService.add({
                      severity: 'error',
                      summary: 'Error',
                      detail: error.error.message,
                  });
              },
          })
      );
      }
  }

  // Open Web Chat
  emitUpdatedChatType(chatType:{label:string,type:ChatType}){
    this.selectedModel = this.defaultModel;

    this.chatServices.setModelSelection(this.selectedModel);
    if(this.chatType === chatType?.type){
        this.chatServices.emitUpdateChatType({label:'QIQ Chat',type:ChatType.Normal});
    }
    else{
        this.chatServices.emitUpdateChatType(chatType);
        this.chatServices.emitCreateChat(this.activeChat);
    }

  }

  updatechatDocsProcessing(count:number){
    if(this.chatType === ChatType.deepResearch) {
        return;
    }
    this.chatDocsProcessingCount = count;
    this.syncMemoryChatAvailability();

    if (this.chatDocsProcessingCount > 0) {
        this.inputText = this.uploadingPlaceholderText;
        this.isUploadPlaceholderActive = true;
        this.setEditorEditableMode(false);
        return;
    }

    this.setEditorEditableMode(true);
    if (this.isUploadPlaceholderActive) {
        this.inputText = '';
        this.isUploadPlaceholderActive = false;
    }
  }

  updateChatDocs(event:boolean){
    if(event){
      this.chatDocuments.getChatDocuments()
      this.generatingReplyBool = true;
      this.getChatInteractions();
      this.syncMemoryChatAvailability();
    }
  }

  async downloadInteractionContainerHTML() {
    if (!this.interactionContainer || this.interactionContainer.length === 0) {
      console.warn("No content to download.");
      return;
    }

    const chatName = await this.resolveChatName();
    const fileName = this.buildDownloadFileName(chatName);
    
    const elementPromises = this.prepareElementsForDownload();
    const elementsHtml = await Promise.all(elementPromises);
    
    const htmlContent = elementsHtml.join('\n\n');
    if (!htmlContent) {
      console.warn("No content to download.");
      return;
    }

    const styles = this.extractPageStyles();
    const completeHTML = this.buildCompleteHTML(chatName, htmlContent, styles);
    this.downloadHTMLFile(completeHTML, fileName);
  }

  private prepareElementsForDownload(): Promise<string>[] {
    const elementPromises: Promise<string>[] = [];

    this.interactionContainer.forEach((elRef) => {
      if (!elRef.nativeElement) return;
      const promise = this.processElementForDownload(elRef.nativeElement);
      elementPromises.push(promise);
    });

    return elementPromises;
  }

  private async processElementForDownload(element: HTMLElement): Promise<string> {
    const clonedElement = element.cloneNode(true) as HTMLElement;
    this.removeUnwantedElements(clonedElement);

    const images = clonedElement.querySelectorAll('img');
    const imagePromises = this.prepareImageConversions(images);

    await Promise.all(imagePromises).catch(() => {});
    return clonedElement.outerHTML;
  }

  private removeUnwantedElements(element: HTMLElement): void {
    element
      .querySelectorAll('.feedback, .replyImage, .bi, .image-loader')
      .forEach(icon => icon.remove());
  }

  private prepareImageConversions(images: NodeListOf<HTMLImageElement>): Promise<void>[] {
    const imagePromises: Promise<void>[] = [];

    images.forEach((img) => {
      const imageUrl = img.src;
      if (!this.shouldProcessImage(imageUrl)) return;

      const promise = this.convertImageToBase64(imageUrl)
        .then(base64 => { img.src = base64; })
        .catch(error => console.warn("Image conversion failed:", imageUrl, error));

      imagePromises.push(promise);
    });

    return imagePromises;
  }

  private shouldProcessImage(imageUrl: string): boolean {
    const isExternal = imageUrl.startsWith('http://') || imageUrl.startsWith('https://');
    const isBlob = imageUrl.startsWith('blob:');
    return isExternal || isBlob;
  }

  private async convertImageToBase64(imageUrl: string): Promise<string> {
    const response = await fetch(imageUrl);
    const blob = await response.blob();

    return new Promise<string>((resolve, reject) => {
      const reader = new FileReader();
      reader.onloadend = () => resolve(reader.result as string);
      reader.onerror = reject;
      reader.readAsDataURL(blob);
    });
  }

  private extractPageStyles(): string {
    let styles = '';

    for (const sheet of Array.from(document.styleSheets)) {
      try {
        if (sheet.cssRules) {
          styles += Array.from(sheet.cssRules)
            .map(rule => rule.cssText)
            .join('\n');
        }
      } catch {
        // Silently skip sheets with access restrictions
      }
    }

    return styles;
  }

  private buildCompleteHTML(chatName: string, htmlContent: string, styles: string): string {
    return `
      <html>
        <head>
          <meta charset="UTF-8">
          <title>${chatName} - Interaction Containers</title>
          <style>${styles}</style>
          <style>
            .question { padding: 6px 15px !important; margin: 0px !important; }
            .reply { padding: 6px 15px !important; }
            h2 { padding: 8px; }
          </style>
        </head>
        <body>
          <h2>${chatName}</h2>
          ${htmlContent}
        </body>
      </html>
    `;
  }

  private downloadHTMLFile(html: string, fileName: string): void {
    const blob = new Blob([html], { type: 'text/html' });
    const link = document.createElement('a');
    link.href = URL.createObjectURL(blob);
    link.download = fileName;
    document.body.appendChild(link);
    link.click();
    link.remove();
  }

  private async resolveChatName(): Promise<string> {
    if (!this.activeChat?.chatId) {
      return this.activeChat?.chatName || 'Chat';
    }

    try {
      const refreshedChat = await lastValueFrom(this.chatServices.getchatById(this.activeChat.chatId));
      if (refreshedChat) {
        this.activeChat = { ...this.activeChat, ...refreshedChat };
        this.chatServices.updateActiveChatObs(this.activeChat);
        this.chatServices.updateActiveChat(this.activeChat);
        if (refreshedChat.chatName) {
          return refreshedChat.chatName;
        }
      }
    } catch (error) {
      console.warn('Unable to refresh chat title before download:', error);
    }

    return this.activeChat?.chatName || 'Chat';
  }

    private buildDownloadFileName(chatName: string): string {
    const safeName =
      chatName?.trim()
        .replaceAll(/[<>:"/\\|?*]+/g, '')
        .replaceAll(/\s+/g, '_') || 'Chat';
    return `${safeName}_${this.getDownloadTimestamp()}_chatInteractions.html`;
  }

  private getDownloadTimestamp(): string {
    const now = new Date();
    const pad = (value: number) => value.toString().padStart(2, '0');
    return `${pad(now.getDate())}-${pad(now.getMonth() + 1)}-${now.getFullYear()}_
    ${pad(now.getHours())}-${pad(now.getMinutes())}-${pad(now.getSeconds())}`;
  }

  handleEditedQuestion(event: { editedText: string, chatId: string, interactionId: string, isEdit: boolean }): void {
    const editIndex = this.chatMessages.findIndex(msg => msg.interactionId === event.interactionId);
    if (editIndex !== -1) {
      // Replace the object to trigger change detection and clear response instantly
      this.chatMessages[editIndex] = {
        ...this.chatMessages[editIndex],
        response: [],
        chatStatus: this.chatStatusWaiting,
        request: {
          ...this.chatMessages[editIndex].request,
          requestText: event.editedText
        }
      };
      // Remove all subsequent messages
      this.chatMessages = this.chatMessages.slice(0, editIndex + 1);
    }
    // Scroll to bottom immediately after UI update
    // setTimeout(() => this.scrollToBottom(), 0);
    // Continue with sending the message as before
    this.responseTimeout = false;
    if (this.isActiveChat()) {
        this.generatingReplyBool = true;
        this.sendQuestionLoader = true;
        this.activeChat = this.chatServices.getActiveChat();
        if (this.activeChat == undefined) {
            this.createNewChat();
        } else {
            this.sendMessage(event);
        }
    }
  }

  onMemoryToggleChange(event: any): void {
      this.chatServices.memoryChat = event.checked;
  }

  onModelChange(event: any): void {
    this.selectedModel = event.value;

    // Turn off Memory Chat if Selected Option doesn't support this feature
    if(this.selectedModel.featuresSupported?.memorySupport === false &&
        this.chatServices.memoryChat){
            this.memoryToggle = false;
            this.chatServices.memoryChat = false;
    }
    // Restore main branch behavior: always update model selection in service
    this.chatServices.setModelSelection(this.selectedModel);
  }

  onReasoningModeChange(reasoningMode: ReasoningModeInput): void {
    this.selectedReasoningMode = reasoningMode;
    this.chatServices.setReasoningModeSelection(reasoningMode);
  }

  onPromptTemplateChange(template: { name: string; label: string; description?: string }): void {
    this.hasPromptDropdownBeenInteractedWith = true;
    if (this.isModelSelectionDisabled) return;
    this.selectedPromptTemplate = template;
    this.chatServices.setPromptTemplateSelection(template);
    this.promptLoading = true;
    this.promptError = null;

    // Determine if there's an active chat
    const activeChat = this.chatServices.getActiveChat();
    let chatId: string | undefined;

    if (activeChat?.chatId) {
        chatId = activeChat.chatId;
        // Log for debugging
        console.log(`Active chat ID: ${chatId}, Chat's activePromptTemplate before change: ${activeChat.activePromptTemplate}`);
    }

    // Log for debugging
    console.log(`Calling setActivePromptForUser with template: ${template.name}, chatId: ${chatId}`);

    // Call the updated service method that can handle both chat-specific and user-level updates
    this.promptService.setActivePromptForUser(template.name, chatId).subscribe({
        next: (response) => {
            // The response will contain the activePrompt, which should match template.name
            if (response.activePrompt === template.name) {
                
                if (response.activePrompt !== 'Default') {
                    this.messageService.add({
                        severity: 'success',
                        summary: 'Prompt Updated',
                        detail: `Prompt template changed to ${template.label}`,
                        life: 3000
                    });
                }
                
                // Log for debugging
                console.debug(`Successfully set active prompt to: ${template.name}`);
                
                // Update the active chat's activePromptTemplate if there's an active chat
                if (activeChat?.chatId) {
                    activeChat.activePromptTemplate = template.name;
                    console.debug(`Updated active chat's activePromptTemplate to: ${template.name}`);
                }
            } else {
                this.promptError = 'Failed to set active prompt template';
                this.messageService.add({
                    severity: 'error',
                    summary: 'Prompt Assignment Error',
                    detail: `Failed to set active prompt. Expected: ${template.name}, Got: ${response.activePrompt}`,
                    life: 5000
                });
                // Log for debugging
                console.error(`Failed to set active prompt. Expected: ${template.name}, Got: ${response.activePrompt}`);
            }
            this.promptLoading = false;
        },
        error: (err) => {
            this.promptError = err.message || 'An unexpected error occurred';
            this.promptLoading = false;
            this.messageService.add({
                severity: 'error',
                summary: 'Prompt Assignment Error',
                detail: this.promptError,
                life: 5000
            });
            // Log for debugging
            console.error(`Error setting active prompt: ${this.promptError}`);
        }
    });
  }

  isImageUploadedInCurrentChat(){
    return this.chatMessages?.some(message => message.request?.images?.length) ?? false;
  }

  trackByInteractionId(index: number, interaction: IChatInteraction): string {
    return interaction.interactionId;
  }

}
